import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  GenericScalar: any;
  JSON: any;
  Upload: any;
};

export type AddUserInput = {
  email: Scalars['String'];
  job_title_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type Calendar = {
  color?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  project?: Maybe<ProjectInfo>;
  start_date?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type CallSheet = {
  category?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  confirmed_participants?: Maybe<Scalars['Int']>;
  creative_document?: Maybe<Array<Maybe<CreativeDocument>>>;
  date: Scalars['String'];
  day_final?: Maybe<Scalars['Int']>;
  day_start?: Maybe<Scalars['Int']>;
  events?: Maybe<Array<Maybe<CallSheetEvent>>>;
  file_url?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  location?: Maybe<Array<Maybe<Location>>>;
  participant?: Maybe<Array<Maybe<CallSheetParticipant>>>;
  participant_by_category?: Maybe<Array<Maybe<Category>>>;
  project?: Maybe<ProjectInfo>;
  schedule?: Maybe<Array<Maybe<CallSheetSchedule>>>;
  send?: Maybe<Scalars['Boolean']>;
  temperature?: Maybe<Scalars['Float']>;
  temperature_max?: Maybe<Scalars['Float']>;
  temperature_min?: Maybe<Scalars['Float']>;
  time?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  total_participants?: Maybe<Scalars['Int']>;
};

export type CallSheetEvent = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  time: Scalars['String'];
};

export type CallSheetEventInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  time: Scalars['String'];
};

export type CallSheetLocation = {
  files?: Maybe<Array<Maybe<LocationFile>>>;
  id: Scalars['String'];
  location_contact?: Maybe<Scalars['String']>;
  location_notes?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  nearest_hospital_address?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['String']>;
  parking_address?: Maybe<Scalars['String']>;
  parking_instructions?: Maybe<Scalars['String']>;
  project_id?: Maybe<Scalars['String']>;
  set_address: Scalars['String'];
};

export type CallSheetParticipant = {
  confirmation_date?: Maybe<Scalars['String']>;
  deleted?: Maybe<Scalars['Boolean']>;
  group?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  time: Scalars['String'];
  user: UserNode;
};

export type CallSheetParticipantInfo = {
  confirmation_date?: Maybe<Scalars['String']>;
  deleted?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['String']>;
  user_name?: Maybe<Scalars['String']>;
};

export type CallSheetParticipantInput = {
  email: Scalars['String'];
  id: Scalars['String'];
  time?: Maybe<Scalars['String']>;
};

export type CallSheetSchedule = {
  call_sheet_id: Scalars['String'];
  cast: Scalars['String'];
  deleted?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  location: Scalars['String'];
  scene: Scalars['String'];
  time: Scalars['String'];
};

export type CallSheetScheduleInput = {
  cast: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  location: Scalars['String'];
  scene: Scalars['String'];
  time: Scalars['String'];
};

export type CallSheetScheduleUpdateInput = {
  cast?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  scene: Scalars['String'];
  time?: Maybe<Scalars['String']>;
};

export type Category = {
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  users: Array<UserNode>;
};

export type CategoryParticipantCallSheet = {
  name: Scalars['String'];
  participants: Array<CallSheetParticipant>;
};

export type City = {
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type Company = {
  company_name?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  id?: Maybe<Scalars['String']>;
};

export type CompanyInfo = {
  address?: Maybe<Scalars['String']>;
  company_managers?: Maybe<Array<Maybe<UserNode>>>;
  company_name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  url_file?: Maybe<Scalars['String']>;
};

export type CompanyLogo = {
  company_id?: Maybe<Scalars['String']>;
  url_file: Scalars['String'];
};

export type CompanyManagerInput = {
  user_id?: Maybe<Scalars['String']>;
};

export type Country = {
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type CreativeDocument = {
  assigned_in_call_sheet?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  document_type?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['String']>;
  file_name?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  link_url?: Maybe<Scalars['String']>;
};

export type CreativeDocumentsInput = {
  document?: Maybe<Scalars['String']>;
  file_name: Scalars['String'];
  link_url?: Maybe<Scalars['String']>;
};

export type Dictionary = {
  content?: Maybe<Scalars['JSON']>;
};

export type JobTitle = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
};

export type KitRental = {
  id?: Maybe<Scalars['String']>;
  item?: Maybe<Array<Maybe<KitRentalItem>>>;
  name?: Maybe<Scalars['String']>;
  user?: Maybe<UserNode>;
};

export type KitRentalByProject = {
  id?: Maybe<Scalars['String']>;
  list_kit_rental?: Maybe<Array<Maybe<KitRental>>>;
  peer_day?: Maybe<Scalars['Boolean']>;
  peer_week?: Maybe<Scalars['Boolean']>;
  project?: Maybe<Scalars['String']>;
  rental_rate?: Maybe<Scalars['Float']>;
  week?: Maybe<Scalars['String']>;
};

export type KitRentalItem = {
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type KitRentalItemInput = {
  name: Scalars['String'];
  value?: Maybe<Scalars['Float']>;
};

export type ListCreativeDocument = {
  count?: Maybe<Scalars['Int']>;
  creative_document?: Maybe<Array<Maybe<CreativeDocument>>>;
};

export type ListProject = {
  count?: Maybe<Scalars['Int']>;
  current_page?: Maybe<Scalars['Int']>;
  num_pages?: Maybe<Scalars['Int']>;
  per_page?: Maybe<Scalars['Int']>;
  results?: Maybe<Array<Maybe<ProjectInfo>>>;
};

export type Location = {
  assigned_in_call_sheet?: Maybe<Scalars['Boolean']>;
  city?: Maybe<City>;
  country?: Maybe<Country>;
  files?: Maybe<Array<Maybe<LocationFile>>>;
  id: Scalars['String'];
  link_maps_hospital_address?: Maybe<Scalars['String']>;
  link_maps_parking_address?: Maybe<Scalars['String']>;
  link_maps_set_address?: Maybe<Scalars['String']>;
  location_contact?: Maybe<Scalars['String']>;
  location_notes?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  nearest_hospital_address?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  parking_address?: Maybe<Scalars['String']>;
  parking_instructions?: Maybe<Scalars['String']>;
  project_id?: Maybe<Scalars['String']>;
  set_address: Scalars['String'];
  zipcode?: Maybe<Scalars['String']>;
};

export type LocationFile = {
  file: Scalars['String'];
  file_name?: Maybe<Scalars['String']>;
  id: Scalars['String'];
};

export type LocationFileInput = {
  file: Scalars['String'];
  file_name?: Maybe<Scalars['String']>;
};

export type LocationInput = {
  id: Scalars['String'];
  order: Scalars['Int'];
};

export type Message = {
  error?: Maybe<Scalars['JSON']>;
  message?: Maybe<Scalars['String']>;
};

export type Mutation = {
  acceptCallSheetInvitation?: Maybe<Scalars['String']>;
  addCalendar?: Maybe<Calendar>;
  addCallSheet?: Maybe<CallSheet>;
  addCompanyManager?: Maybe<UserNode>;
  addKitRental?: Maybe<KitRental>;
  addKitRentalByProject?: Maybe<KitRentalByProject>;
  addLocation?: Maybe<Location>;
  addNote?: Maybe<Note>;
  addUserProject?: Maybe<Scalars['String']>;
  changeProjectState: Scalars['String'];
  companySignup: Company;
  createProject?: Maybe<ProjectInfo>;
  deleteCalendar?: Maybe<Scalars['String']>;
  deleteCallSheet?: Maybe<CallSheet>;
  deleteCompanyManager: Scalars['String'];
  deleteCreativeDocument?: Maybe<Scalars['String']>;
  deleteLocation?: Maybe<Scalars['String']>;
  deleteNote?: Maybe<Scalars['String']>;
  deleteUserProject?: Maybe<Scalars['String']>;
  forgotPassword: Scalars['String'];
  logout: Scalars['String'];
  refreshToken?: Maybe<RefreshToken>;
  resendVerificationEmail: Scalars['String'];
  resetPassword: Scalars['String'];
  revokeToken?: Maybe<RevokeToken>;
  sendCallSheetDocument?: Maybe<Message>;
  sendProjectInvitation?: Maybe<Scalars['String']>;
  tokenAuth?: Maybe<ResultTokenAuth>;
  updateCalendar?: Maybe<Scalars['String']>;
  updateCallSheet?: Maybe<CallSheet>;
  updateDocumentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  updateLocation?: Maybe<Location>;
  updateNote?: Maybe<Note>;
  updateProfile: UserNode;
  updateProject?: Maybe<ProjectInfo>;
  updateUserProject?: Maybe<Scalars['String']>;
  uploadCompanyLogo: CompanyLogo;
  uploadCreativeDocument?: Maybe<Array<Maybe<Scalars['String']>>>;
  userSignup: UserSignup;
  verifyEmail: ResultTokenAuth;
  verifyToken?: Maybe<VerifyToken>;
};


export type MutationAcceptCallSheetInvitationArgs = {
  callSheetId: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationAddCalendarArgs = {
  color: Scalars['String'];
  end_date: Scalars['Date'];
  project_id: Scalars['String'];
  start_date: Scalars['Date'];
  title: Scalars['String'];
};


export type MutationAddCallSheetArgs = {
  category?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  creative_document?: Maybe<Array<Maybe<Scalars['String']>>>;
  date: Scalars['String'];
  day_final?: Maybe<Scalars['Int']>;
  day_start?: Maybe<Scalars['Int']>;
  events?: Maybe<Array<Maybe<CallSheetEventInput>>>;
  location?: Maybe<Array<Maybe<LocationInput>>>;
  participant?: Maybe<Array<Maybe<CallSheetParticipantInput>>>;
  project_id: Scalars['String'];
  schedule?: Maybe<Array<Maybe<CallSheetScheduleInput>>>;
  temperature?: Maybe<Scalars['Float']>;
  temperature_max?: Maybe<Scalars['Float']>;
  temperature_min?: Maybe<Scalars['Float']>;
  time: Scalars['String'];
  title: Scalars['String'];
};


export type MutationAddCompanyManagerArgs = {
  user_id: Scalars['String'];
};


export type MutationAddKitRentalArgs = {
  item?: Maybe<Array<Maybe<KitRentalItemInput>>>;
  name: Scalars['String'];
  user_id: Scalars['String'];
};


export type MutationAddKitRentalByProjectArgs = {
  kit_rental_ids: Array<Maybe<Scalars['Int']>>;
  peer_day: Scalars['Boolean'];
  peer_week: Scalars['Boolean'];
  project_id: Scalars['String'];
  rental_rate: Scalars['Float'];
  week_id: Scalars['Int'];
};


export type MutationAddLocationArgs = {
  city_id?: Maybe<Scalars['Int']>;
  country_id?: Maybe<Scalars['Int']>;
  files?: Maybe<Array<Maybe<LocationFileInput>>>;
  link_maps_hospital_address?: Maybe<Scalars['String']>;
  link_maps_parking_address?: Maybe<Scalars['String']>;
  link_maps_set_address?: Maybe<Scalars['String']>;
  location_contact?: Maybe<Scalars['String']>;
  location_notes?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  nearest_hospital_address?: Maybe<Scalars['String']>;
  parking_address?: Maybe<Scalars['String']>;
  parking_instructions?: Maybe<Scalars['String']>;
  project_id: Scalars['String'];
  set_address: Scalars['String'];
  zipcode?: Maybe<Scalars['String']>;
};


export type MutationAddNoteArgs = {
  content?: Maybe<Scalars['String']>;
  project_id: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  user_id: Scalars['String'];
};


export type MutationAddUserProjectArgs = {
  project_id: Scalars['String'];
  users: Array<AddUserInput>;
};


export type MutationChangeProjectStateArgs = {
  project_id: Scalars['String'];
  state: Scalars['String'];
};


export type MutationCompanySignupArgs = {
  address: Scalars['String'];
  companyName: Scalars['String'];
  confirmPassword: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
  phone: Scalars['String'];
};


export type MutationCreateProjectArgs = {
  client_logo?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['String']>;
  company_manager?: Maybe<Array<Maybe<CompanyManagerInput>>>;
  end_date: Scalars['Date'];
  num_project?: Maybe<Scalars['String']>;
  project_manager: Array<Maybe<ProjectManagerInput>>;
  project_name: Scalars['String'];
  start_date: Scalars['Date'];
};


export type MutationDeleteCalendarArgs = {
  calendar_id: Scalars['String'];
};


export type MutationDeleteCallSheetArgs = {
  call_sheet_id: Scalars['String'];
};


export type MutationDeleteCompanyManagerArgs = {
  user_id: Scalars['String'];
};


export type MutationDeleteCreativeDocumentArgs = {
  documents: Array<Scalars['String']>;
};


export type MutationDeleteLocationArgs = {
  locations: Array<Maybe<Scalars['String']>>;
};


export type MutationDeleteNoteArgs = {
  note_id: Scalars['Int'];
};


export type MutationDeleteUserProjectArgs = {
  project_id: Scalars['String'];
  users: Array<AddUserInput>;
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationRefreshTokenArgs = {
  token: Scalars['String'];
};


export type MutationResendVerificationEmailArgs = {
  email: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  confirmPassword: Scalars['String'];
  password: Scalars['String'];
  token: Scalars['String'];
};


export type MutationRevokeTokenArgs = {
  refresh_token: Scalars['String'];
};


export type MutationSendCallSheetDocumentArgs = {
  addMeToEmailList?: Maybe<Scalars['Boolean']>;
  callSheetId: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  resetConfirmations?: Maybe<Scalars['Boolean']>;
  sendSMS?: Maybe<Scalars['Boolean']>;
  sendTest?: Maybe<Scalars['Boolean']>;
};


export type MutationSendProjectInvitationArgs = {
  project_id: Scalars['String'];
  users: Array<UserInvitationInput>;
};


export type MutationTokenAuthArgs = {
  email_or_phone?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  socialAuthProvider?: Maybe<SocialAuthProvider>;
  tokenID?: Maybe<Scalars['String']>;
};


export type MutationUpdateCalendarArgs = {
  calendar_id: Scalars['String'];
  color?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['Date']>;
  start_date?: Maybe<Scalars['Date']>;
  title?: Maybe<Scalars['String']>;
};


export type MutationUpdateCallSheetArgs = {
  add_creative_document?: Maybe<Array<Maybe<Scalars['String']>>>;
  add_or_update_events?: Maybe<Array<Maybe<CallSheetEventInput>>>;
  add_or_update_location?: Maybe<Array<Maybe<LocationInput>>>;
  add_or_update_participant?: Maybe<Array<Maybe<CallSheetParticipantInput>>>;
  add_or_update_schedule?: Maybe<Array<Maybe<CallSheetScheduleUpdateInput>>>;
  category?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  day_final?: Maybe<Scalars['Int']>;
  day_start?: Maybe<Scalars['Int']>;
  delete_creative_document?: Maybe<Array<Maybe<Scalars['String']>>>;
  delete_events?: Maybe<Array<Maybe<Scalars['String']>>>;
  delete_location?: Maybe<Array<Maybe<Scalars['String']>>>;
  delete_participant?: Maybe<Array<Maybe<CallSheetParticipantInput>>>;
  delete_schedule?: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Scalars['String'];
  temperature?: Maybe<Scalars['Float']>;
  temperature_max?: Maybe<Scalars['Float']>;
  temperature_min?: Maybe<Scalars['Float']>;
  time?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};


export type MutationUpdateDocumentTypeArgs = {
  documents: Array<UpdateDocumentTypeInput>;
};


export type MutationUpdateLocationArgs = {
  add_files?: Maybe<Array<Maybe<LocationFileInput>>>;
  city_id?: Maybe<Scalars['Int']>;
  country_id?: Maybe<Scalars['Int']>;
  delete_files?: Maybe<Array<Maybe<Scalars['String']>>>;
  link_maps_hospital_address?: Maybe<Scalars['String']>;
  link_maps_parking_address?: Maybe<Scalars['String']>;
  link_maps_set_address?: Maybe<Scalars['String']>;
  location_contact?: Maybe<Scalars['String']>;
  location_id: Scalars['String'];
  location_notes?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nearest_hospital_address?: Maybe<Scalars['String']>;
  parking_address?: Maybe<Scalars['String']>;
  parking_instructions?: Maybe<Scalars['String']>;
  set_address?: Maybe<Scalars['String']>;
  zipcode?: Maybe<Scalars['String']>;
};


export type MutationUpdateNoteArgs = {
  content?: Maybe<Scalars['String']>;
  note_id: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
};


export type MutationUpdateProfileArgs = {
  avatar?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  job_title_id?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
};


export type MutationUpdateProjectArgs = {
  client_logo?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['String']>;
  company_manager?: Maybe<Array<Maybe<CompanyManagerInput>>>;
  end_date?: Maybe<Scalars['Date']>;
  id: Scalars['String'];
  num_project?: Maybe<Scalars['String']>;
  project_manager?: Maybe<Array<Maybe<ProjectManagerInput>>>;
  project_name?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['Date']>;
};


export type MutationUpdateUserProjectArgs = {
  project_id: Scalars['String'];
  users: Array<AddUserInput>;
};


export type MutationUploadCompanyLogoArgs = {
  logo: Scalars['Upload'];
};


export type MutationUploadCreativeDocumentArgs = {
  documents: Array<CreativeDocumentsInput>;
  project_id: Scalars['String'];
};


export type MutationUserSignupArgs = {
  confirmPassword: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  job_title_id: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
  phone: Scalars['String'];
};


export type MutationVerifyEmailArgs = {
  token: Scalars['String'];
};


export type MutationVerifyTokenArgs = {
  token: Scalars['String'];
};

export type Note = {
  content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  project?: Maybe<ProjectInfo>;
  title?: Maybe<Scalars['String']>;
  user?: Maybe<UserNode>;
};

export type ProjectInfo = {
  client_logo_url?: Maybe<Scalars['String']>;
  company?: Maybe<CompanyInfo>;
  company_managers?: Maybe<Array<Maybe<ProjectUserNode>>>;
  end_date?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  is_new_project?: Maybe<Scalars['Boolean']>;
  num_project?: Maybe<Scalars['String']>;
  project_managers?: Maybe<Array<Maybe<ProjectUserNode>>>;
  project_name?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type ProjectManagerInput = {
  job_title_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  user_role?: Maybe<Scalars['String']>;
};

export type ProjectUserNode = {
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  job_title?: Maybe<JobTitle>;
  last_name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  url_avatar?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  user_role?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type Query = {
  checkRecoveryPasswordToken: Scalars['String'];
  checkVerifyEmailToken: Scalars['String'];
  companyInfo?: Maybe<CompanyInfo>;
  companyList?: Maybe<Array<Maybe<Company>>>;
  getCalendar?: Maybe<Calendar>;
  getCallSheet?: Maybe<CallSheet>;
  getCompanyManagerList?: Maybe<Array<Maybe<UserNode>>>;
  getInfoCallSheetParticipant?: Maybe<CallSheetParticipantInfo>;
  getNote?: Maybe<Note>;
  getParticipantsForCallSheet?: Maybe<Array<Maybe<Category>>>;
  getProject?: Maybe<ProjectInfo>;
  hasProducerPermission?: Maybe<Scalars['Boolean']>;
  labels?: Maybe<Dictionary>;
  listCalendars?: Maybe<Array<Maybe<Calendar>>>;
  listCallSheet?: Maybe<Array<Maybe<CallSheet>>>;
  listCities?: Maybe<Array<Maybe<City>>>;
  listCountries?: Maybe<Array<Maybe<Country>>>;
  listCreativeDocument?: Maybe<ListCreativeDocument>;
  listJobTitle?: Maybe<Array<Maybe<JobTitle>>>;
  listKitRental?: Maybe<Array<Maybe<KitRental>>>;
  listKitRentalByProject?: Maybe<Array<Maybe<KitRentalByProject>>>;
  listLocations?: Maybe<Array<Maybe<Location>>>;
  listNotes?: Maybe<Array<Maybe<Note>>>;
  listProject?: Maybe<ListProject>;
  listWeeks?: Maybe<Array<Maybe<Week>>>;
  me?: Maybe<UserNode>;
  ping: Scalars['String'];
  roleByProject?: Maybe<Role>;
  userInfo?: Maybe<UserInfo>;
  userList?: Maybe<Array<Maybe<UserNode>>>;
  userListForProject?: Maybe<Array<Maybe<UserNode>>>;
  userListFromProject?: Maybe<Array<Maybe<UserNode>>>;
  userRoleList?: Maybe<Array<Maybe<UserRoleNode>>>;
};


export type QueryCheckRecoveryPasswordTokenArgs = {
  token: Scalars['String'];
};


export type QueryCheckVerifyEmailTokenArgs = {
  token: Scalars['String'];
};


export type QueryCompanyInfoArgs = {
  company_id?: Maybe<Scalars['String']>;
};


export type QueryGetCalendarArgs = {
  calendar_id: Scalars['String'];
};


export type QueryGetCallSheetArgs = {
  call_sheet_id: Scalars['String'];
};


export type QueryGetCompanyManagerListArgs = {
  name_or_email: Scalars['String'];
  user_limit?: Maybe<Scalars['Int']>;
};


export type QueryGetInfoCallSheetParticipantArgs = {
  call_sheet_id: Scalars['String'];
  participant_id: Scalars['String'];
};


export type QueryGetNoteArgs = {
  note_id: Scalars['Int'];
};


export type QueryGetParticipantsForCallSheetArgs = {
  call_sheet_id?: Maybe<Scalars['String']>;
  name_or_email?: Maybe<Scalars['String']>;
  project_id: Scalars['String'];
  user_limit?: Maybe<Scalars['Int']>;
};


export type QueryGetProjectArgs = {
  project_id: Scalars['String'];
};


export type QueryHasProducerPermissionArgs = {
  project_id: Scalars['String'];
};


export type QueryLabelsArgs = {
  language?: Maybe<Scalars['String']>;
};


export type QueryListCalendarsArgs = {
  project_id: Scalars['String'];
  since_date?: Maybe<Scalars['String']>;
  until_date?: Maybe<Scalars['String']>;
};


export type QueryListCallSheetArgs = {
  project_id: Scalars['String'];
};


export type QueryListCitiesArgs = {
  country_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};


export type QueryListCountriesArgs = {
  name?: Maybe<Scalars['String']>;
};


export type QueryListCreativeDocumentArgs = {
  file_name?: Maybe<Scalars['String']>;
  project_id: Scalars['String'];
};


export type QueryListJobTitleArgs = {
  limit?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};


export type QueryListKitRentalArgs = {
  user_id: Scalars['String'];
};


export type QueryListKitRentalByProjectArgs = {
  project_id: Scalars['String'];
  week_id: Scalars['Int'];
};


export type QueryListLocationsArgs = {
  location_id?: Maybe<Scalars['String']>;
  project_id: Scalars['String'];
};


export type QueryListNotesArgs = {
  project_id: Scalars['String'];
  user_id: Scalars['String'];
};


export type QueryListProjectArgs = {
  page?: Maybe<Scalars['Int']>;
  per_page: Scalars['Int'];
  status?: Maybe<Scalars['String']>;
  user_type?: Maybe<Scalars['String']>;
};


export type QueryRoleByProjectArgs = {
  project_id: Scalars['String'];
};


export type QueryUserListArgs = {
  company_id: Scalars['String'];
  name_or_email: Scalars['String'];
  user_limit?: Maybe<Scalars['Int']>;
};


export type QueryUserListForProjectArgs = {
  name_or_email: Scalars['String'];
  project_id: Scalars['String'];
  user_limit?: Maybe<Scalars['Int']>;
};


export type QueryUserListFromProjectArgs = {
  name_or_email: Scalars['String'];
  project_id: Scalars['String'];
  user_limit?: Maybe<Scalars['Int']>;
};

export type RefreshToken = {
  payload?: Maybe<Scalars['GenericScalar']>;
  refresh_token?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type ResultTokenAuth = {
  payload?: Maybe<Scalars['GenericScalar']>;
  refresh_token?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type RevokeToken = {
  revoked?: Maybe<Scalars['Int']>;
};

export type Role = {
  role?: Maybe<Scalars['String']>;
};

export enum SocialAuthProvider {
  Apple = 'APPLE',
  Facebook = 'FACEBOOK',
  Google = 'GOOGLE'
}

export type TokenAuth = {
  payload?: Maybe<Scalars['GenericScalar']>;
  refresh_token?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type UpdateDocumentTypeInput = {
  document_id: Scalars['String'];
  document_type: Scalars['String'];
};

export type UserInfo = {
  company?: Maybe<CompanyInfo>;
  crew_members_projects: Scalars['Int'];
  producers_projects: Scalars['Int'];
  user?: Maybe<UserNode>;
};

export type UserInvitationInput = {
  email: Scalars['String'];
  job_title_id?: Maybe<Scalars['String']>;
};

export type UserNode = {
  approved_call_sheet?: Maybe<Scalars['Boolean']>;
  assigned_in_call_sheet?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  job_title?: Maybe<JobTitle>;
  last_name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  time_call_sheet?: Maybe<Scalars['String']>;
  url_avatar?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type UserRoleNode = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type UserSignup = {
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  job_title_id: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
};

export type VerifyToken = {
  payload?: Maybe<Scalars['GenericScalar']>;
};

export type Week = {
  end_date?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['String']>;
};

export type AcceptCallSheetInvitationMutationVariables = Exact<{
  userId: Scalars['String'];
  callSheetId: Scalars['String'];
}>;


export type AcceptCallSheetInvitationMutation = { acceptCallSheetInvitation?: string | null | undefined };

export type AddCalendarMutationVariables = Exact<{
  project_id: Scalars['String'];
  title: Scalars['String'];
  start_date: Scalars['Date'];
  end_date: Scalars['Date'];
  color: Scalars['String'];
}>;


export type AddCalendarMutation = { addCalendar?: { id?: string | null | undefined, start_date?: string | null | undefined, end_date?: string | null | undefined, title?: string | null | undefined, color?: string | null | undefined } | null | undefined };

export type AddCallSheetMutationVariables = Exact<{
  project_id: Scalars['String'];
  title: Scalars['String'];
  date: Scalars['String'];
  time: Scalars['String'];
  comment?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  location: Array<Maybe<LocationInput>> | Maybe<LocationInput>;
  creative_document: Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>;
  schedule: Array<Maybe<CallSheetScheduleInput>> | Maybe<CallSheetScheduleInput>;
  participant: Array<Maybe<CallSheetParticipantInput>> | Maybe<CallSheetParticipantInput>;
  day_start?: Maybe<Scalars['Int']>;
  day_final?: Maybe<Scalars['Int']>;
  temperature?: Maybe<Scalars['Float']>;
  temperature_max?: Maybe<Scalars['Float']>;
  temperature_min?: Maybe<Scalars['Float']>;
  events?: Maybe<Array<Maybe<CallSheetEventInput>> | Maybe<CallSheetEventInput>>;
}>;


export type AddCallSheetMutation = { addCallSheet?: { id: string, title: string, date: string, confirmed_participants?: number | null | undefined, total_participants?: number | null | undefined, project?: { id?: string | null | undefined, num_project?: string | null | undefined, project_name?: string | null | undefined, start_date?: string | null | undefined, end_date?: string | null | undefined, state?: string | null | undefined, status?: string | null | undefined, is_new_project?: boolean | null | undefined, company?: { id?: string | null | undefined, company_name?: string | null | undefined, address?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, url_file?: string | null | undefined, company_managers?: Array<{ id?: string | null | undefined, username?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, full_name?: string | null | undefined, url_avatar?: string | null | undefined, job_title?: { id?: string | null | undefined, order?: number | null | undefined, name?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined, company_managers?: Array<{ id?: string | null | undefined, user_id?: string | null | undefined, username?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, full_name?: string | null | undefined, user_role?: string | null | undefined, url_avatar?: string | null | undefined } | null | undefined> | null | undefined, project_managers?: Array<{ id?: string | null | undefined, user_id?: string | null | undefined, username?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, full_name?: string | null | undefined, user_role?: string | null | undefined, url_avatar?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, creative_document?: Array<{ id: string, file?: string | null | undefined, file_name?: string | null | undefined, document_type?: string | null | undefined, date?: string | null | undefined, created_by?: string | null | undefined } | null | undefined> | null | undefined, location?: Array<{ id: string, name: string, set_address: string, project_id?: string | null | undefined, parking_address?: string | null | undefined, parking_instructions?: string | null | undefined, nearest_hospital_address?: string | null | undefined, location_contact?: string | null | undefined, location_notes?: string | null | undefined, order?: number | null | undefined, files?: Array<{ id: string, file: string, file_name?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined, schedule?: Array<{ id: string, call_sheet_id: string, scene: string, description?: string | null | undefined, cast: string, location: string, time: string, deleted?: boolean | null | undefined } | null | undefined> | null | undefined, participant?: Array<{ id?: string | null | undefined, group?: string | null | undefined, time: string, deleted?: boolean | null | undefined, user: { id?: string | null | undefined, username?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, full_name?: string | null | undefined, url_avatar?: string | null | undefined, job_title?: { id?: string | null | undefined, name?: string | null | undefined } | null | undefined } } | null | undefined> | null | undefined } | null | undefined };

export type AddCompanyManagerMutationVariables = Exact<{
  user_id: Scalars['String'];
}>;


export type AddCompanyManagerMutation = { addCompanyManager?: { id?: string | null | undefined, email?: string | null | undefined, full_name?: string | null | undefined, phone?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined } | null | undefined };

export type AddLocationMutationVariables = Exact<{
  project_id: Scalars['String'];
  name: Scalars['String'];
  set_address: Scalars['String'];
  country_id?: Maybe<Scalars['Int']>;
  zipcode?: Maybe<Scalars['String']>;
  parking_address?: Maybe<Scalars['String']>;
  parking_instructions?: Maybe<Scalars['String']>;
  nearest_hospital_address?: Maybe<Scalars['String']>;
  location_contact?: Maybe<Scalars['String']>;
  location_notes?: Maybe<Scalars['String']>;
  link_maps_set_address?: Maybe<Scalars['String']>;
  link_maps_parking_address?: Maybe<Scalars['String']>;
  link_maps_hospital_address?: Maybe<Scalars['String']>;
  files?: Maybe<Array<Maybe<LocationFileInput>> | Maybe<LocationFileInput>>;
}>;


export type AddLocationMutation = { addLocation?: { id: string } | null | undefined };

export type AddNoteMutationVariables = Exact<{
  project_id: Scalars['String'];
  user_id: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
}>;


export type AddNoteMutation = { addNote?: { id?: number | null | undefined } | null | undefined };

export type AddUserProjectMutationVariables = Exact<{
  project_id: Scalars['String'];
  users: Array<AddUserInput> | AddUserInput;
}>;


export type AddUserProjectMutation = { addUserProject?: string | null | undefined };

export type ChangeProjectStateMutationVariables = Exact<{
  project_id: Scalars['String'];
  state: Scalars['String'];
}>;


export type ChangeProjectStateMutation = { changeProjectState: string };

export type CompanySignupMutationVariables = Exact<{
  companyName: Scalars['String'];
  address: Scalars['String'];
  email: Scalars['String'];
  phone: Scalars['String'];
  password: Scalars['String'];
  confirmPassword: Scalars['String'];
}>;


export type CompanySignupMutation = { companySignup: { id?: string | null | undefined, company_name?: string | null | undefined, email: string } };

export type CreateProjectMutationVariables = Exact<{
  company_id?: Maybe<Scalars['String']>;
  project_name: Scalars['String'];
  start_date: Scalars['Date'];
  end_date: Scalars['Date'];
  num_project?: Maybe<Scalars['String']>;
  company_manager?: Maybe<Array<Maybe<CompanyManagerInput>> | Maybe<CompanyManagerInput>>;
  project_manager: Array<Maybe<ProjectManagerInput>> | Maybe<ProjectManagerInput>;
  client_logo?: Maybe<Scalars['String']>;
}>;


export type CreateProjectMutation = { createProject?: { id?: string | null | undefined } | null | undefined };

export type DeleteCalendarMutationVariables = Exact<{
  calendar_id: Scalars['String'];
}>;


export type DeleteCalendarMutation = { deleteCalendar?: string | null | undefined };

export type DeleteCompanyManagerMutationVariables = Exact<{
  user_id: Scalars['String'];
}>;


export type DeleteCompanyManagerMutation = { deleteCompanyManager: string };

export type DeleteCreativeDocumentMutationVariables = Exact<{
  documents: Array<Scalars['String']> | Scalars['String'];
}>;


export type DeleteCreativeDocumentMutation = { deleteCreativeDocument?: string | null | undefined };

export type DeleteLocationMutationVariables = Exact<{
  locations: Array<Scalars['String']> | Scalars['String'];
}>;


export type DeleteLocationMutation = { deleteLocation?: string | null | undefined };

export type DeleteNoteMutationVariables = Exact<{
  note_id: Scalars['Int'];
}>;


export type DeleteNoteMutation = { deleteNote?: string | null | undefined };

export type DeleteUserProjectMutationVariables = Exact<{
  project_id: Scalars['String'];
  users: Array<AddUserInput> | AddUserInput;
}>;


export type DeleteUserProjectMutation = { deleteUserProject?: string | null | undefined };

export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ForgotPasswordMutation = { forgotPassword: string };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { logout: string };

export type ResendVerificationEmailMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ResendVerificationEmailMutation = { resendVerificationEmail: string };

export type ResetPasswordMutationVariables = Exact<{
  token: Scalars['String'];
  password: Scalars['String'];
  confirmPassword: Scalars['String'];
}>;


export type ResetPasswordMutation = { resetPassword: string };

export type SendCallSheetDocumentMutationVariables = Exact<{
  callSheetId: Scalars['String'];
  sendTest?: Maybe<Scalars['Boolean']>;
  addMeToEmailList?: Maybe<Scalars['Boolean']>;
  sendSMS?: Maybe<Scalars['Boolean']>;
  resetConfirmations?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
}>;


export type SendCallSheetDocumentMutation = { sendCallSheetDocument?: { message?: string | null | undefined, error?: any | null | undefined } | null | undefined };

export type TokenAuthMutationVariables = Exact<{
  email_or_phone: Scalars['String'];
  password?: Maybe<Scalars['String']>;
  socialAuthProvider?: Maybe<SocialAuthProvider>;
  tokenID?: Maybe<Scalars['String']>;
}>;


export type TokenAuthMutation = { tokenAuth?: { token?: string | null | undefined, refresh_token?: string | null | undefined, payload?: any | null | undefined } | null | undefined };

export type UpdateCalendarMutationVariables = Exact<{
  calendar_id: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['Date']>;
  end_date?: Maybe<Scalars['Date']>;
  color?: Maybe<Scalars['String']>;
}>;


export type UpdateCalendarMutation = { updateCalendar?: string | null | undefined };

export type UpdateCallSheetMutationVariables = Exact<{
  id: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['String']>;
  day_start?: Maybe<Scalars['Int']>;
  day_final?: Maybe<Scalars['Int']>;
  temperature?: Maybe<Scalars['Float']>;
  temperature_max?: Maybe<Scalars['Float']>;
  temperature_min?: Maybe<Scalars['Float']>;
  comment?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  add_or_update_events?: Maybe<Array<Maybe<CallSheetEventInput>> | Maybe<CallSheetEventInput>>;
  delete_events?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  add_or_update_location?: Maybe<Array<Maybe<LocationInput>> | Maybe<LocationInput>>;
  delete_location?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  add_creative_document?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  delete_creative_document?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  add_or_update_schedule?: Maybe<Array<Maybe<CallSheetScheduleUpdateInput>> | Maybe<CallSheetScheduleUpdateInput>>;
  delete_schedule?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  add_or_update_participant?: Maybe<Array<Maybe<CallSheetParticipantInput>> | Maybe<CallSheetParticipantInput>>;
  delete_participant?: Maybe<Array<Maybe<CallSheetParticipantInput>> | Maybe<CallSheetParticipantInput>>;
}>;


export type UpdateCallSheetMutation = { updateCallSheet?: { id: string } | null | undefined };

export type UpdateDocumentTypeMutationVariables = Exact<{
  documents: Array<UpdateDocumentTypeInput> | UpdateDocumentTypeInput;
}>;


export type UpdateDocumentTypeMutation = { updateDocumentType?: Array<string | null | undefined> | null | undefined };

export type UpdateLocationMutationVariables = Exact<{
  location_id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  set_address?: Maybe<Scalars['String']>;
  zipcode?: Maybe<Scalars['String']>;
  country_id?: Maybe<Scalars['Int']>;
  parking_address?: Maybe<Scalars['String']>;
  link_maps_set_address?: Maybe<Scalars['String']>;
  link_maps_parking_address?: Maybe<Scalars['String']>;
  link_maps_hospital_address?: Maybe<Scalars['String']>;
  parking_instructions?: Maybe<Scalars['String']>;
  nearest_hospital_address?: Maybe<Scalars['String']>;
  location_contact?: Maybe<Scalars['String']>;
  location_notes?: Maybe<Scalars['String']>;
  add_files?: Maybe<Array<Maybe<LocationFileInput>> | Maybe<LocationFileInput>>;
  delete_files?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
}>;


export type UpdateLocationMutation = { updateLocation?: { id: string } | null | undefined };

export type UpdateNoteMutationVariables = Exact<{
  note_id: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  content: Scalars['String'];
}>;


export type UpdateNoteMutation = { updateNote?: { id?: number | null | undefined } | null | undefined };

export type UpdateProfileMutationVariables = Exact<{
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  job_title_id?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
}>;


export type UpdateProfileMutation = { updateProfile: { id?: string | null | undefined, username?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, full_name?: string | null | undefined, url_avatar?: string | null | undefined, job_title?: { id?: string | null | undefined, name?: string | null | undefined } | null | undefined } };

export type UpdateProjectMutationVariables = Exact<{
  id: Scalars['String'];
  company_id?: Maybe<Scalars['String']>;
  project_name?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['Date']>;
  end_date?: Maybe<Scalars['Date']>;
  num_project?: Maybe<Scalars['String']>;
  company_manager?: Maybe<Array<Maybe<CompanyManagerInput>> | Maybe<CompanyManagerInput>>;
  project_manager?: Maybe<Array<Maybe<ProjectManagerInput>> | Maybe<ProjectManagerInput>>;
  client_logo?: Maybe<Scalars['String']>;
}>;


export type UpdateProjectMutation = { updateProject?: { id?: string | null | undefined } | null | undefined };

export type UpdateUserProjectMutationVariables = Exact<{
  project_id: Scalars['String'];
  users: Array<AddUserInput> | AddUserInput;
}>;


export type UpdateUserProjectMutation = { updateUserProject?: string | null | undefined };

export type UploadCompanyLogoMutationVariables = Exact<{
  logo: Scalars['Upload'];
}>;


export type UploadCompanyLogoMutation = { uploadCompanyLogo: { company_id?: string | null | undefined, url_file: string } };

export type UploadCreativeDocumentMutationVariables = Exact<{
  project_id: Scalars['String'];
  documents: Array<CreativeDocumentsInput> | CreativeDocumentsInput;
}>;


export type UploadCreativeDocumentMutation = { uploadCreativeDocument?: Array<string | null | undefined> | null | undefined };

export type UserSignupMutationVariables = Exact<{
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  jobTitle: Scalars['String'];
  phone: Scalars['String'];
  password: Scalars['String'];
  confirmPassword: Scalars['String'];
}>;


export type UserSignupMutation = { userSignup: { id?: string | null | undefined, firstName: string, lastName: string, email?: string | null | undefined, job_title_id: string, phone: string } };

export type VerifyEmailMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type VerifyEmailMutation = { verifyEmail: { token?: string | null | undefined, refresh_token?: string | null | undefined, payload?: any | null | undefined } };

export type CompanyInfoQueryVariables = Exact<{
  company_id: Scalars['String'];
}>;


export type CompanyInfoQuery = { companyInfo?: { id?: string | null | undefined, address?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, company_name?: string | null | undefined, url_file?: string | null | undefined, company_managers?: Array<{ id?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, full_name?: string | null | undefined, url_avatar?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type CompanyListQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyListQuery = { companyList?: Array<{ id?: string | null | undefined, company_name?: string | null | undefined, email: string } | null | undefined> | null | undefined };

export type GetCompanyManagerListQueryVariables = Exact<{
  name_or_email: Scalars['String'];
}>;


export type GetCompanyManagerListQuery = { getCompanyManagerList?: Array<{ id?: string | null | undefined, email?: string | null | undefined, full_name?: string | null | undefined, url_avatar?: string | null | undefined, phone?: string | null | undefined } | null | undefined> | null | undefined };

export type GetCallSheetQueryVariables = Exact<{
  call_sheet_id: Scalars['String'];
}>;


export type GetCallSheetQuery = { getCallSheet?: { id: string, title: string, time?: string | null | undefined, date: string, day_start?: number | null | undefined, day_final?: number | null | undefined, file_url?: string | null | undefined, temperature?: number | null | undefined, temperature_max?: number | null | undefined, temperature_min?: number | null | undefined, comment?: string | null | undefined, category?: string | null | undefined, confirmed_participants?: number | null | undefined, total_participants?: number | null | undefined, s3_url?: string | null | undefined, project?: { id?: string | null | undefined, client_logo_url?: string | null | undefined, num_project?: string | null | undefined, project_name?: string | null | undefined, start_date?: string | null | undefined, end_date?: string | null | undefined, state?: string | null | undefined, status?: string | null | undefined, is_new_project?: boolean | null | undefined, company?: { id?: string | null | undefined, company_name?: string | null | undefined, address?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, url_file?: string | null | undefined, company_managers?: Array<{ id?: string | null | undefined, username?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, full_name?: string | null | undefined, url_avatar?: string | null | undefined, job_title?: { id?: string | null | undefined, order?: number | null | undefined, name?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined, company_managers?: Array<{ id?: string | null | undefined, user_id?: string | null | undefined, username?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, full_name?: string | null | undefined, user_role?: string | null | undefined, url_avatar?: string | null | undefined } | null | undefined> | null | undefined, project_managers?: Array<{ id?: string | null | undefined, user_id?: string | null | undefined, username?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, full_name?: string | null | undefined, user_role?: string | null | undefined, url_avatar?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, events?: Array<{ id?: string | null | undefined, name: string, time: string } | null | undefined> | null | undefined, creative_document?: Array<{ id: string, file?: string | null | undefined, file_name?: string | null | undefined, link_url?: string | null | undefined, document_type?: string | null | undefined, date?: string | null | undefined, created_by?: string | null | undefined, assigned_in_call_sheet?: boolean | null | undefined } | null | undefined> | null | undefined, location?: Array<{ id: string, name: string, set_address: string, zipcode?: string | null | undefined, project_id?: string | null | undefined, parking_address?: string | null | undefined, parking_instructions?: string | null | undefined, nearest_hospital_address?: string | null | undefined, location_contact?: string | null | undefined, location_notes?: string | null | undefined, order?: number | null | undefined, link_maps_set_address?: string | null | undefined, link_maps_parking_address?: string | null | undefined, link_maps_hospital_address?: string | null | undefined, assigned_in_call_sheet?: boolean | null | undefined, files?: Array<{ id: string, file: string, file_name?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined, schedule?: Array<{ id: string, call_sheet_id: string, scene: string, description?: string | null | undefined, cast: string, location: string, time: string, deleted?: boolean | null | undefined } | null | undefined> | null | undefined, participant?: Array<{ id?: string | null | undefined, group?: string | null | undefined, time: string, deleted?: boolean | null | undefined, user: { id?: string | null | undefined, username?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, full_name?: string | null | undefined, url_avatar?: string | null | undefined, job_title?: { id?: string | null | undefined, name?: string | null | undefined } | null | undefined } } | null | undefined> | null | undefined, participant_by_category?: Array<{ name: string, title?: string | null | undefined, users: Array<{ approved_call_sheet?: boolean | null | undefined, time_call_sheet?: string | null | undefined, assigned_in_call_sheet?: boolean | null | undefined, full_name?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, job_title?: { id?: string | null | undefined, name?: string | null | undefined } | null | undefined }> } | null | undefined> | null | undefined } | null | undefined };

export type GetInfoCallSheetParticipantQueryVariables = Exact<{
  call_sheet_id: Scalars['String'];
  participant_id: Scalars['String'];
}>;


export type GetInfoCallSheetParticipantQuery = { getInfoCallSheetParticipant?: { user_name?: string | null | undefined, time?: string | null | undefined, confirmation_date?: string | null | undefined } | null | undefined };

export type GetParticipantsForCallSheetQueryVariables = Exact<{
  name_or_email?: Maybe<Scalars['String']>;
  project_id: Scalars['String'];
  user_limit?: Maybe<Scalars['Int']>;
  call_sheet_id?: Maybe<Scalars['String']>;
}>;


export type GetParticipantsForCallSheetQuery = { getParticipantsForCallSheet?: Array<{ name: string, title?: string | null | undefined, users: Array<{ id?: string | null | undefined, full_name?: string | null | undefined, username?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, assigned_in_call_sheet?: boolean | null | undefined, time_call_sheet?: string | null | undefined, approved_call_sheet?: boolean | null | undefined, job_title?: { id?: string | null | undefined, name?: string | null | undefined } | null | undefined }> } | null | undefined> | null | undefined };

export type GetProjectQueryVariables = Exact<{
  project_id: Scalars['String'];
}>;


export type GetProjectQuery = { getProject?: { id?: string | null | undefined, client_logo_url?: string | null | undefined, start_date?: string | null | undefined, project_name?: string | null | undefined, end_date?: string | null | undefined, num_project?: string | null | undefined, company?: { id?: string | null | undefined, email?: string | null | undefined, company_name?: string | null | undefined, company_managers?: Array<{ id?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, full_name?: string | null | undefined, url_avatar?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, company_managers?: Array<{ user_id?: string | null | undefined, user_role?: string | null | undefined, full_name?: string | null | undefined, url_avatar?: string | null | undefined } | null | undefined> | null | undefined, project_managers?: Array<{ user_id?: string | null | undefined, user_role?: string | null | undefined, full_name?: string | null | undefined, url_avatar?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type ListCalendarsQueryVariables = Exact<{
  project_id: Scalars['String'];
  since_date?: Maybe<Scalars['String']>;
  until_date?: Maybe<Scalars['String']>;
}>;


export type ListCalendarsQuery = { listCalendars?: Array<{ id?: string | null | undefined, title?: string | null | undefined, start_date?: string | null | undefined, end_date?: string | null | undefined, color?: string | null | undefined } | null | undefined> | null | undefined };

export type ListCallSheetQueryVariables = Exact<{
  project_id: Scalars['String'];
}>;


export type ListCallSheetQuery = { listCallSheet?: Array<{ id: string, title: string, time?: string | null | undefined, day_start?: number | null | undefined, day_final?: number | null | undefined, send?: boolean | null | undefined, file_url?: string | null | undefined, date: string, comment?: string | null | undefined, category?: string | null | undefined, confirmed_participants?: number | null | undefined, total_participants?: number | null | undefined, project?: { id?: string | null | undefined, num_project?: string | null | undefined, client_logo_url?: string | null | undefined, project_name?: string | null | undefined, start_date?: string | null | undefined, end_date?: string | null | undefined, state?: string | null | undefined, status?: string | null | undefined, is_new_project?: boolean | null | undefined, company?: { id?: string | null | undefined, company_name?: string | null | undefined, address?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, url_file?: string | null | undefined, company_managers?: Array<{ id?: string | null | undefined, username?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, full_name?: string | null | undefined, url_avatar?: string | null | undefined, job_title?: { id?: string | null | undefined, order?: number | null | undefined, name?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined, company_managers?: Array<{ id?: string | null | undefined, user_id?: string | null | undefined, username?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, full_name?: string | null | undefined, user_role?: string | null | undefined, url_avatar?: string | null | undefined } | null | undefined> | null | undefined, project_managers?: Array<{ id?: string | null | undefined, user_id?: string | null | undefined, username?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, full_name?: string | null | undefined, user_role?: string | null | undefined, url_avatar?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, creative_document?: Array<{ id: string, file?: string | null | undefined, file_name?: string | null | undefined, document_type?: string | null | undefined, date?: string | null | undefined, created_by?: string | null | undefined } | null | undefined> | null | undefined, location?: Array<{ id: string, name: string, set_address: string, project_id?: string | null | undefined, parking_address?: string | null | undefined, parking_instructions?: string | null | undefined, nearest_hospital_address?: string | null | undefined, location_contact?: string | null | undefined, location_notes?: string | null | undefined, order?: number | null | undefined, files?: Array<{ id: string, file: string, file_name?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined, schedule?: Array<{ id: string, call_sheet_id: string, scene: string, description?: string | null | undefined, cast: string, location: string, time: string, deleted?: boolean | null | undefined } | null | undefined> | null | undefined, participant?: Array<{ id?: string | null | undefined, group?: string | null | undefined, time: string, deleted?: boolean | null | undefined, user: { id?: string | null | undefined, username?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, full_name?: string | null | undefined, url_avatar?: string | null | undefined, job_title?: { id?: string | null | undefined, name?: string | null | undefined } | null | undefined } } | null | undefined> | null | undefined } | null | undefined> | null | undefined };

export type ListCityQueryVariables = Exact<{
  name?: Maybe<Scalars['String']>;
  country_id?: Maybe<Scalars['Int']>;
}>;


export type ListCityQuery = { listCities?: Array<{ id?: number | null | undefined, name?: string | null | undefined } | null | undefined> | null | undefined };

export type ListCreativeDocumentQueryVariables = Exact<{
  project_id: Scalars['String'];
}>;


export type ListCreativeDocumentQuery = { listCreativeDocument?: { count?: number | null | undefined, creative_document?: Array<{ id: string, file?: string | null | undefined, file_name?: string | null | undefined, document_type?: string | null | undefined, date?: string | null | undefined, link_url?: string | null | undefined, created_by?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type ListDifferentProjectsQueryVariables = Exact<{
  user_type: Scalars['String'];
  per_page: Scalars['Int'];
}>;


export type ListDifferentProjectsQuery = { review?: { count?: number | null | undefined, current_page?: number | null | undefined, per_page?: number | null | undefined, results?: Array<{ id?: string | null | undefined, project_name?: string | null | undefined, client_logo_url?: string | null | undefined, start_date?: string | null | undefined, end_date?: string | null | undefined, status?: string | null | undefined, num_project?: string | null | undefined, is_new_project?: boolean | null | undefined, company?: { id?: string | null | undefined, company_name?: string | null | undefined, address?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, url_file?: string | null | undefined } | null | undefined, company_managers?: Array<{ id?: string | null | undefined, user_id?: string | null | undefined, user_role?: string | null | undefined, username?: string | null | undefined, url_avatar?: string | null | undefined, full_name?: string | null | undefined } | null | undefined> | null | undefined, project_managers?: Array<{ id?: string | null | undefined, user_id?: string | null | undefined, user_role?: string | null | undefined, username?: string | null | undefined, phone?: string | null | undefined, url_avatar?: string | null | undefined, full_name?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined, rejected?: { count?: number | null | undefined, current_page?: number | null | undefined, per_page?: number | null | undefined, results?: Array<{ id?: string | null | undefined, project_name?: string | null | undefined, client_logo_url?: string | null | undefined, start_date?: string | null | undefined, end_date?: string | null | undefined, status?: string | null | undefined, num_project?: string | null | undefined, is_new_project?: boolean | null | undefined, company?: { id?: string | null | undefined, company_name?: string | null | undefined, address?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, url_file?: string | null | undefined } | null | undefined, company_managers?: Array<{ id?: string | null | undefined, user_id?: string | null | undefined, user_role?: string | null | undefined, username?: string | null | undefined, url_avatar?: string | null | undefined, full_name?: string | null | undefined } | null | undefined> | null | undefined, project_managers?: Array<{ id?: string | null | undefined, user_id?: string | null | undefined, user_role?: string | null | undefined, username?: string | null | undefined, phone?: string | null | undefined, url_avatar?: string | null | undefined, full_name?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined, onGoing?: { count?: number | null | undefined, current_page?: number | null | undefined, per_page?: number | null | undefined, results?: Array<{ id?: string | null | undefined, project_name?: string | null | undefined, client_logo_url?: string | null | undefined, start_date?: string | null | undefined, end_date?: string | null | undefined, status?: string | null | undefined, num_project?: string | null | undefined, is_new_project?: boolean | null | undefined, company?: { id?: string | null | undefined, company_name?: string | null | undefined, address?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, url_file?: string | null | undefined } | null | undefined, company_managers?: Array<{ id?: string | null | undefined, user_id?: string | null | undefined, user_role?: string | null | undefined, username?: string | null | undefined, url_avatar?: string | null | undefined, full_name?: string | null | undefined } | null | undefined> | null | undefined, project_managers?: Array<{ id?: string | null | undefined, user_id?: string | null | undefined, user_role?: string | null | undefined, username?: string | null | undefined, phone?: string | null | undefined, url_avatar?: string | null | undefined, full_name?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined, done?: { count?: number | null | undefined, current_page?: number | null | undefined, per_page?: number | null | undefined, results?: Array<{ id?: string | null | undefined, project_name?: string | null | undefined, client_logo_url?: string | null | undefined, start_date?: string | null | undefined, end_date?: string | null | undefined, status?: string | null | undefined, num_project?: string | null | undefined, is_new_project?: boolean | null | undefined, company?: { id?: string | null | undefined, company_name?: string | null | undefined, address?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, url_file?: string | null | undefined } | null | undefined, company_managers?: Array<{ id?: string | null | undefined, user_id?: string | null | undefined, user_role?: string | null | undefined, username?: string | null | undefined, url_avatar?: string | null | undefined, full_name?: string | null | undefined } | null | undefined> | null | undefined, project_managers?: Array<{ id?: string | null | undefined, user_id?: string | null | undefined, user_role?: string | null | undefined, username?: string | null | undefined, phone?: string | null | undefined, url_avatar?: string | null | undefined, full_name?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type ListJobTitleQueryVariables = Exact<{
  name?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type ListJobTitleQuery = { listJobTitle?: Array<{ id?: string | null | undefined, name?: string | null | undefined } | null | undefined> | null | undefined };

export type ListLocationsQueryVariables = Exact<{
  project_id: Scalars['String'];
}>;


export type ListLocationsQuery = { listLocations?: Array<{ id: string, name: string, set_address: string, project_id?: string | null | undefined, parking_address?: string | null | undefined, parking_instructions?: string | null | undefined, nearest_hospital_address?: string | null | undefined, location_notes?: string | null | undefined, location_contact?: string | null | undefined, link_maps_set_address?: string | null | undefined, link_maps_parking_address?: string | null | undefined, link_maps_hospital_address?: string | null | undefined, zipcode?: string | null | undefined, city?: { id?: number | null | undefined, name?: string | null | undefined } | null | undefined, files?: Array<{ id: string, file: string, file_name?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined };

export type ListNotesQueryVariables = Exact<{
  project_id: Scalars['String'];
  user_id: Scalars['String'];
}>;


export type ListNotesQuery = { listNotes?: Array<{ id?: number | null | undefined, title?: string | null | undefined, content?: string | null | undefined } | null | undefined> | null | undefined };

export type ListProjectQueryVariables = Exact<{
  per_page: Scalars['Int'];
  status?: Maybe<Scalars['String']>;
  user_type?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
}>;


export type ListProjectQuery = { listProject?: { count?: number | null | undefined, current_page?: number | null | undefined, per_page?: number | null | undefined, results?: Array<{ id?: string | null | undefined, project_name?: string | null | undefined, client_logo_url?: string | null | undefined, start_date?: string | null | undefined, end_date?: string | null | undefined, status?: string | null | undefined, num_project?: string | null | undefined, is_new_project?: boolean | null | undefined, company?: { id?: string | null | undefined, company_name?: string | null | undefined, address?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, url_file?: string | null | undefined, company_managers?: Array<{ id?: string | null | undefined, username?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, full_name?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, company_managers?: Array<{ id?: string | null | undefined, user_id?: string | null | undefined, user_role?: string | null | undefined, username?: string | null | undefined, url_avatar?: string | null | undefined } | null | undefined> | null | undefined, project_managers?: Array<{ id?: string | null | undefined, user_id?: string | null | undefined, user_role?: string | null | undefined, username?: string | null | undefined, phone?: string | null | undefined, url_avatar?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type PingQueryVariables = Exact<{ [key: string]: never; }>;


export type PingQuery = { ping: string };

export type RoleByProjectQueryVariables = Exact<{
  project_id: Scalars['String'];
}>;


export type RoleByProjectQuery = { roleByProject?: { role?: string | null | undefined } | null | undefined };

export type UserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type UserInfoQuery = { userInfo?: { producers_projects: number, crew_members_projects: number, user?: { id?: string | null | undefined, username?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, full_name?: string | null | undefined, url_avatar?: string | null | undefined, job_title?: { id?: string | null | undefined, name?: string | null | undefined } | null | undefined } | null | undefined, company?: { id?: string | null | undefined, company_name?: string | null | undefined, address?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, url_file?: string | null | undefined } | null | undefined } | null | undefined };

export type UserListQueryVariables = Exact<{
  name_or_email: Scalars['String'];
  company_id: Scalars['String'];
  user_limit?: Maybe<Scalars['Int']>;
}>;


export type UserListQuery = { userList?: Array<{ id?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, full_name?: string | null | undefined, email?: string | null | undefined } | null | undefined> | null | undefined };

export type UserListForProjectQueryVariables = Exact<{
  name_or_email: Scalars['String'];
  project_id: Scalars['String'];
  user_limit?: Maybe<Scalars['Int']>;
}>;


export type UserListForProjectQuery = { userListForProject?: Array<{ id?: string | null | undefined, full_name?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, job_title?: { name?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined };

export type UserListFromProjectQueryVariables = Exact<{
  name_or_email: Scalars['String'];
  project_id: Scalars['String'];
  user_limit?: Maybe<Scalars['Int']>;
}>;


export type UserListFromProjectQuery = { userListFromProject?: Array<{ id?: string | null | undefined, full_name?: string | null | undefined, email?: string | null | undefined, url_avatar?: string | null | undefined, phone?: string | null | undefined, job_title?: { name?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined };


export const AcceptCallSheetInvitationDocument = gql`
    mutation AcceptCallSheetInvitation($userId: String!, $callSheetId: String!) {
  acceptCallSheetInvitation(userId: $userId, callSheetId: $callSheetId)
}
    `;
export type AcceptCallSheetInvitationMutationFn = Apollo.MutationFunction<AcceptCallSheetInvitationMutation, AcceptCallSheetInvitationMutationVariables>;

/**
 * __useAcceptCallSheetInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptCallSheetInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptCallSheetInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptCallSheetInvitationMutation, { data, loading, error }] = useAcceptCallSheetInvitationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      callSheetId: // value for 'callSheetId'
 *   },
 * });
 */
export function useAcceptCallSheetInvitationMutation(baseOptions?: Apollo.MutationHookOptions<AcceptCallSheetInvitationMutation, AcceptCallSheetInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptCallSheetInvitationMutation, AcceptCallSheetInvitationMutationVariables>(AcceptCallSheetInvitationDocument, options);
      }
export type AcceptCallSheetInvitationMutationHookResult = ReturnType<typeof useAcceptCallSheetInvitationMutation>;
export type AcceptCallSheetInvitationMutationResult = Apollo.MutationResult<AcceptCallSheetInvitationMutation>;
export type AcceptCallSheetInvitationMutationOptions = Apollo.BaseMutationOptions<AcceptCallSheetInvitationMutation, AcceptCallSheetInvitationMutationVariables>;
export const AddCalendarDocument = gql`
    mutation AddCalendar($project_id: String!, $title: String!, $start_date: Date!, $end_date: Date!, $color: String!) {
  addCalendar(
    project_id: $project_id
    title: $title
    start_date: $start_date
    end_date: $end_date
    color: $color
  ) {
    id
    start_date
    end_date
    title
    color
  }
}
    `;
export type AddCalendarMutationFn = Apollo.MutationFunction<AddCalendarMutation, AddCalendarMutationVariables>;

/**
 * __useAddCalendarMutation__
 *
 * To run a mutation, you first call `useAddCalendarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCalendarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCalendarMutation, { data, loading, error }] = useAddCalendarMutation({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      title: // value for 'title'
 *      start_date: // value for 'start_date'
 *      end_date: // value for 'end_date'
 *      color: // value for 'color'
 *   },
 * });
 */
export function useAddCalendarMutation(baseOptions?: Apollo.MutationHookOptions<AddCalendarMutation, AddCalendarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCalendarMutation, AddCalendarMutationVariables>(AddCalendarDocument, options);
      }
export type AddCalendarMutationHookResult = ReturnType<typeof useAddCalendarMutation>;
export type AddCalendarMutationResult = Apollo.MutationResult<AddCalendarMutation>;
export type AddCalendarMutationOptions = Apollo.BaseMutationOptions<AddCalendarMutation, AddCalendarMutationVariables>;
export const AddCallSheetDocument = gql`
    mutation AddCallSheet($project_id: String!, $title: String!, $date: String!, $time: String!, $comment: String, $category: String, $location: [LocationInput]!, $creative_document: [String]!, $schedule: [CallSheetScheduleInput]!, $participant: [CallSheetParticipantInput]!, $day_start: Int, $day_final: Int, $temperature: Float, $temperature_max: Float, $temperature_min: Float, $events: [CallSheetEventInput]) {
  addCallSheet(
    project_id: $project_id
    title: $title
    date: $date
    time: $time
    comment: $comment
    category: $category
    location: $location
    creative_document: $creative_document
    schedule: $schedule
    participant: $participant
    day_start: $day_start
    day_final: $day_final
    temperature: $temperature
    temperature_max: $temperature_max
    temperature_min: $temperature_min
    events: $events
  ) {
    id
    project {
      id
      num_project
      project_name
      start_date
      end_date
      state
      status
      is_new_project
      company {
        id
        company_name
        address
        email
        phone
        url_file
        company_managers {
          id
          username
          email
          phone
          first_name
          last_name
          full_name
          url_avatar
          job_title {
            id
            order
            name
          }
        }
      }
      company_managers {
        id
        user_id
        username
        email
        phone
        first_name
        last_name
        full_name
        user_role
        url_avatar
      }
      project_managers {
        id
        user_id
        username
        email
        phone
        first_name
        last_name
        full_name
        user_role
        url_avatar
      }
    }
    title
    date
    confirmed_participants
    total_participants
    creative_document {
      id
      file
      file_name
      document_type
      date
      created_by
    }
    location {
      id
      name
      set_address
      project_id
      parking_address
      parking_instructions
      nearest_hospital_address
      location_contact
      location_notes
      order
      files {
        id
        file
        file_name
      }
    }
    schedule {
      id
      call_sheet_id
      scene
      description
      cast
      location
      time
      deleted
    }
    participant {
      id
      group
      user {
        id
        username
        email
        phone
        first_name
        last_name
        full_name
        url_avatar
        job_title {
          id
          name
        }
      }
      time
      deleted
    }
  }
}
    `;
export type AddCallSheetMutationFn = Apollo.MutationFunction<AddCallSheetMutation, AddCallSheetMutationVariables>;

/**
 * __useAddCallSheetMutation__
 *
 * To run a mutation, you first call `useAddCallSheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCallSheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCallSheetMutation, { data, loading, error }] = useAddCallSheetMutation({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      title: // value for 'title'
 *      date: // value for 'date'
 *      time: // value for 'time'
 *      comment: // value for 'comment'
 *      category: // value for 'category'
 *      location: // value for 'location'
 *      creative_document: // value for 'creative_document'
 *      schedule: // value for 'schedule'
 *      participant: // value for 'participant'
 *      day_start: // value for 'day_start'
 *      day_final: // value for 'day_final'
 *      temperature: // value for 'temperature'
 *      temperature_max: // value for 'temperature_max'
 *      temperature_min: // value for 'temperature_min'
 *      events: // value for 'events'
 *   },
 * });
 */
export function useAddCallSheetMutation(baseOptions?: Apollo.MutationHookOptions<AddCallSheetMutation, AddCallSheetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCallSheetMutation, AddCallSheetMutationVariables>(AddCallSheetDocument, options);
      }
export type AddCallSheetMutationHookResult = ReturnType<typeof useAddCallSheetMutation>;
export type AddCallSheetMutationResult = Apollo.MutationResult<AddCallSheetMutation>;
export type AddCallSheetMutationOptions = Apollo.BaseMutationOptions<AddCallSheetMutation, AddCallSheetMutationVariables>;
export const AddCompanyManagerDocument = gql`
    mutation AddCompanyManager($user_id: String!) {
  addCompanyManager(user_id: $user_id) {
    id
    email
    full_name
    phone
    first_name
    last_name
  }
}
    `;
export type AddCompanyManagerMutationFn = Apollo.MutationFunction<AddCompanyManagerMutation, AddCompanyManagerMutationVariables>;

/**
 * __useAddCompanyManagerMutation__
 *
 * To run a mutation, you first call `useAddCompanyManagerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyManagerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyManagerMutation, { data, loading, error }] = useAddCompanyManagerMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useAddCompanyManagerMutation(baseOptions?: Apollo.MutationHookOptions<AddCompanyManagerMutation, AddCompanyManagerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCompanyManagerMutation, AddCompanyManagerMutationVariables>(AddCompanyManagerDocument, options);
      }
export type AddCompanyManagerMutationHookResult = ReturnType<typeof useAddCompanyManagerMutation>;
export type AddCompanyManagerMutationResult = Apollo.MutationResult<AddCompanyManagerMutation>;
export type AddCompanyManagerMutationOptions = Apollo.BaseMutationOptions<AddCompanyManagerMutation, AddCompanyManagerMutationVariables>;
export const AddLocationDocument = gql`
    mutation AddLocation($project_id: String!, $name: String!, $set_address: String!, $country_id: Int, $zipcode: String, $parking_address: String, $parking_instructions: String, $nearest_hospital_address: String, $location_contact: String, $location_notes: String, $link_maps_set_address: String, $link_maps_parking_address: String, $link_maps_hospital_address: String, $files: [LocationFileInput]) {
  addLocation(
    project_id: $project_id
    name: $name
    set_address: $set_address
    parking_address: $parking_address
    parking_instructions: $parking_instructions
    nearest_hospital_address: $nearest_hospital_address
    location_contact: $location_contact
    location_notes: $location_notes
    link_maps_set_address: $link_maps_set_address
    link_maps_parking_address: $link_maps_parking_address
    link_maps_hospital_address: $link_maps_hospital_address
    files: $files
    country_id: $country_id
    zipcode: $zipcode
  ) {
    id
  }
}
    `;
export type AddLocationMutationFn = Apollo.MutationFunction<AddLocationMutation, AddLocationMutationVariables>;

/**
 * __useAddLocationMutation__
 *
 * To run a mutation, you first call `useAddLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLocationMutation, { data, loading, error }] = useAddLocationMutation({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      name: // value for 'name'
 *      set_address: // value for 'set_address'
 *      country_id: // value for 'country_id'
 *      zipcode: // value for 'zipcode'
 *      parking_address: // value for 'parking_address'
 *      parking_instructions: // value for 'parking_instructions'
 *      nearest_hospital_address: // value for 'nearest_hospital_address'
 *      location_contact: // value for 'location_contact'
 *      location_notes: // value for 'location_notes'
 *      link_maps_set_address: // value for 'link_maps_set_address'
 *      link_maps_parking_address: // value for 'link_maps_parking_address'
 *      link_maps_hospital_address: // value for 'link_maps_hospital_address'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useAddLocationMutation(baseOptions?: Apollo.MutationHookOptions<AddLocationMutation, AddLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLocationMutation, AddLocationMutationVariables>(AddLocationDocument, options);
      }
export type AddLocationMutationHookResult = ReturnType<typeof useAddLocationMutation>;
export type AddLocationMutationResult = Apollo.MutationResult<AddLocationMutation>;
export type AddLocationMutationOptions = Apollo.BaseMutationOptions<AddLocationMutation, AddLocationMutationVariables>;
export const AddNoteDocument = gql`
    mutation AddNote($project_id: String!, $user_id: String!, $title: String, $content: String) {
  addNote(
    project_id: $project_id
    user_id: $user_id
    title: $title
    content: $content
  ) {
    id
  }
}
    `;
export type AddNoteMutationFn = Apollo.MutationFunction<AddNoteMutation, AddNoteMutationVariables>;

/**
 * __useAddNoteMutation__
 *
 * To run a mutation, you first call `useAddNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNoteMutation, { data, loading, error }] = useAddNoteMutation({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      user_id: // value for 'user_id'
 *      title: // value for 'title'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useAddNoteMutation(baseOptions?: Apollo.MutationHookOptions<AddNoteMutation, AddNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNoteMutation, AddNoteMutationVariables>(AddNoteDocument, options);
      }
export type AddNoteMutationHookResult = ReturnType<typeof useAddNoteMutation>;
export type AddNoteMutationResult = Apollo.MutationResult<AddNoteMutation>;
export type AddNoteMutationOptions = Apollo.BaseMutationOptions<AddNoteMutation, AddNoteMutationVariables>;
export const AddUserProjectDocument = gql`
    mutation AddUserProject($project_id: String!, $users: [AddUserInput!]!) {
  addUserProject(project_id: $project_id, users: $users)
}
    `;
export type AddUserProjectMutationFn = Apollo.MutationFunction<AddUserProjectMutation, AddUserProjectMutationVariables>;

/**
 * __useAddUserProjectMutation__
 *
 * To run a mutation, you first call `useAddUserProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserProjectMutation, { data, loading, error }] = useAddUserProjectMutation({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      users: // value for 'users'
 *   },
 * });
 */
export function useAddUserProjectMutation(baseOptions?: Apollo.MutationHookOptions<AddUserProjectMutation, AddUserProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserProjectMutation, AddUserProjectMutationVariables>(AddUserProjectDocument, options);
      }
export type AddUserProjectMutationHookResult = ReturnType<typeof useAddUserProjectMutation>;
export type AddUserProjectMutationResult = Apollo.MutationResult<AddUserProjectMutation>;
export type AddUserProjectMutationOptions = Apollo.BaseMutationOptions<AddUserProjectMutation, AddUserProjectMutationVariables>;
export const ChangeProjectStateDocument = gql`
    mutation ChangeProjectState($project_id: String!, $state: String!) {
  changeProjectState(project_id: $project_id, state: $state)
}
    `;
export type ChangeProjectStateMutationFn = Apollo.MutationFunction<ChangeProjectStateMutation, ChangeProjectStateMutationVariables>;

/**
 * __useChangeProjectStateMutation__
 *
 * To run a mutation, you first call `useChangeProjectStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeProjectStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeProjectStateMutation, { data, loading, error }] = useChangeProjectStateMutation({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useChangeProjectStateMutation(baseOptions?: Apollo.MutationHookOptions<ChangeProjectStateMutation, ChangeProjectStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeProjectStateMutation, ChangeProjectStateMutationVariables>(ChangeProjectStateDocument, options);
      }
export type ChangeProjectStateMutationHookResult = ReturnType<typeof useChangeProjectStateMutation>;
export type ChangeProjectStateMutationResult = Apollo.MutationResult<ChangeProjectStateMutation>;
export type ChangeProjectStateMutationOptions = Apollo.BaseMutationOptions<ChangeProjectStateMutation, ChangeProjectStateMutationVariables>;
export const CompanySignupDocument = gql`
    mutation CompanySignup($companyName: String!, $address: String!, $email: String!, $phone: String!, $password: String!, $confirmPassword: String!) {
  companySignup(
    companyName: $companyName
    address: $address
    email: $email
    phone: $phone
    password: $password
    confirmPassword: $confirmPassword
  ) {
    id
    company_name
    email
  }
}
    `;
export type CompanySignupMutationFn = Apollo.MutationFunction<CompanySignupMutation, CompanySignupMutationVariables>;

/**
 * __useCompanySignupMutation__
 *
 * To run a mutation, you first call `useCompanySignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanySignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companySignupMutation, { data, loading, error }] = useCompanySignupMutation({
 *   variables: {
 *      companyName: // value for 'companyName'
 *      address: // value for 'address'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      password: // value for 'password'
 *      confirmPassword: // value for 'confirmPassword'
 *   },
 * });
 */
export function useCompanySignupMutation(baseOptions?: Apollo.MutationHookOptions<CompanySignupMutation, CompanySignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanySignupMutation, CompanySignupMutationVariables>(CompanySignupDocument, options);
      }
export type CompanySignupMutationHookResult = ReturnType<typeof useCompanySignupMutation>;
export type CompanySignupMutationResult = Apollo.MutationResult<CompanySignupMutation>;
export type CompanySignupMutationOptions = Apollo.BaseMutationOptions<CompanySignupMutation, CompanySignupMutationVariables>;
export const CreateProjectDocument = gql`
    mutation CreateProject($company_id: String, $project_name: String!, $start_date: Date!, $end_date: Date!, $num_project: String, $company_manager: [CompanyManagerInput], $project_manager: [ProjectManagerInput]!, $client_logo: String) {
  createProject(
    company_id: $company_id
    project_name: $project_name
    start_date: $start_date
    end_date: $end_date
    num_project: $num_project
    company_manager: $company_manager
    project_manager: $project_manager
    client_logo: $client_logo
  ) {
    id
  }
}
    `;
export type CreateProjectMutationFn = Apollo.MutationFunction<CreateProjectMutation, CreateProjectMutationVariables>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      company_id: // value for 'company_id'
 *      project_name: // value for 'project_name'
 *      start_date: // value for 'start_date'
 *      end_date: // value for 'end_date'
 *      num_project: // value for 'num_project'
 *      company_manager: // value for 'company_manager'
 *      project_manager: // value for 'project_manager'
 *      client_logo: // value for 'client_logo'
 *   },
 * });
 */
export function useCreateProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectMutation, CreateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument, options);
      }
export type CreateProjectMutationHookResult = ReturnType<typeof useCreateProjectMutation>;
export type CreateProjectMutationResult = Apollo.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<CreateProjectMutation, CreateProjectMutationVariables>;
export const DeleteCalendarDocument = gql`
    mutation deleteCalendar($calendar_id: String!) {
  deleteCalendar(calendar_id: $calendar_id)
}
    `;
export type DeleteCalendarMutationFn = Apollo.MutationFunction<DeleteCalendarMutation, DeleteCalendarMutationVariables>;

/**
 * __useDeleteCalendarMutation__
 *
 * To run a mutation, you first call `useDeleteCalendarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCalendarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCalendarMutation, { data, loading, error }] = useDeleteCalendarMutation({
 *   variables: {
 *      calendar_id: // value for 'calendar_id'
 *   },
 * });
 */
export function useDeleteCalendarMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCalendarMutation, DeleteCalendarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCalendarMutation, DeleteCalendarMutationVariables>(DeleteCalendarDocument, options);
      }
export type DeleteCalendarMutationHookResult = ReturnType<typeof useDeleteCalendarMutation>;
export type DeleteCalendarMutationResult = Apollo.MutationResult<DeleteCalendarMutation>;
export type DeleteCalendarMutationOptions = Apollo.BaseMutationOptions<DeleteCalendarMutation, DeleteCalendarMutationVariables>;
export const DeleteCompanyManagerDocument = gql`
    mutation DeleteCompanyManager($user_id: String!) {
  deleteCompanyManager(user_id: $user_id)
}
    `;
export type DeleteCompanyManagerMutationFn = Apollo.MutationFunction<DeleteCompanyManagerMutation, DeleteCompanyManagerMutationVariables>;

/**
 * __useDeleteCompanyManagerMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyManagerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyManagerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyManagerMutation, { data, loading, error }] = useDeleteCompanyManagerMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useDeleteCompanyManagerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompanyManagerMutation, DeleteCompanyManagerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompanyManagerMutation, DeleteCompanyManagerMutationVariables>(DeleteCompanyManagerDocument, options);
      }
export type DeleteCompanyManagerMutationHookResult = ReturnType<typeof useDeleteCompanyManagerMutation>;
export type DeleteCompanyManagerMutationResult = Apollo.MutationResult<DeleteCompanyManagerMutation>;
export type DeleteCompanyManagerMutationOptions = Apollo.BaseMutationOptions<DeleteCompanyManagerMutation, DeleteCompanyManagerMutationVariables>;
export const DeleteCreativeDocumentDocument = gql`
    mutation deleteCreativeDocument($documents: [String!]!) {
  deleteCreativeDocument(documents: $documents)
}
    `;
export type DeleteCreativeDocumentMutationFn = Apollo.MutationFunction<DeleteCreativeDocumentMutation, DeleteCreativeDocumentMutationVariables>;

/**
 * __useDeleteCreativeDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteCreativeDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCreativeDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCreativeDocumentMutation, { data, loading, error }] = useDeleteCreativeDocumentMutation({
 *   variables: {
 *      documents: // value for 'documents'
 *   },
 * });
 */
export function useDeleteCreativeDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCreativeDocumentMutation, DeleteCreativeDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCreativeDocumentMutation, DeleteCreativeDocumentMutationVariables>(DeleteCreativeDocumentDocument, options);
      }
export type DeleteCreativeDocumentMutationHookResult = ReturnType<typeof useDeleteCreativeDocumentMutation>;
export type DeleteCreativeDocumentMutationResult = Apollo.MutationResult<DeleteCreativeDocumentMutation>;
export type DeleteCreativeDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteCreativeDocumentMutation, DeleteCreativeDocumentMutationVariables>;
export const DeleteLocationDocument = gql`
    mutation DeleteLocation($locations: [String!]!) {
  deleteLocation(locations: $locations)
}
    `;
export type DeleteLocationMutationFn = Apollo.MutationFunction<DeleteLocationMutation, DeleteLocationMutationVariables>;

/**
 * __useDeleteLocationMutation__
 *
 * To run a mutation, you first call `useDeleteLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationMutation, { data, loading, error }] = useDeleteLocationMutation({
 *   variables: {
 *      locations: // value for 'locations'
 *   },
 * });
 */
export function useDeleteLocationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationMutation, DeleteLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationMutation, DeleteLocationMutationVariables>(DeleteLocationDocument, options);
      }
export type DeleteLocationMutationHookResult = ReturnType<typeof useDeleteLocationMutation>;
export type DeleteLocationMutationResult = Apollo.MutationResult<DeleteLocationMutation>;
export type DeleteLocationMutationOptions = Apollo.BaseMutationOptions<DeleteLocationMutation, DeleteLocationMutationVariables>;
export const DeleteNoteDocument = gql`
    mutation DeleteNote($note_id: Int!) {
  deleteNote(note_id: $note_id)
}
    `;
export type DeleteNoteMutationFn = Apollo.MutationFunction<DeleteNoteMutation, DeleteNoteMutationVariables>;

/**
 * __useDeleteNoteMutation__
 *
 * To run a mutation, you first call `useDeleteNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNoteMutation, { data, loading, error }] = useDeleteNoteMutation({
 *   variables: {
 *      note_id: // value for 'note_id'
 *   },
 * });
 */
export function useDeleteNoteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNoteMutation, DeleteNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNoteMutation, DeleteNoteMutationVariables>(DeleteNoteDocument, options);
      }
export type DeleteNoteMutationHookResult = ReturnType<typeof useDeleteNoteMutation>;
export type DeleteNoteMutationResult = Apollo.MutationResult<DeleteNoteMutation>;
export type DeleteNoteMutationOptions = Apollo.BaseMutationOptions<DeleteNoteMutation, DeleteNoteMutationVariables>;
export const DeleteUserProjectDocument = gql`
    mutation DeleteUserProject($project_id: String!, $users: [AddUserInput!]!) {
  deleteUserProject(project_id: $project_id, users: $users)
}
    `;
export type DeleteUserProjectMutationFn = Apollo.MutationFunction<DeleteUserProjectMutation, DeleteUserProjectMutationVariables>;

/**
 * __useDeleteUserProjectMutation__
 *
 * To run a mutation, you first call `useDeleteUserProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserProjectMutation, { data, loading, error }] = useDeleteUserProjectMutation({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      users: // value for 'users'
 *   },
 * });
 */
export function useDeleteUserProjectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserProjectMutation, DeleteUserProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserProjectMutation, DeleteUserProjectMutationVariables>(DeleteUserProjectDocument, options);
      }
export type DeleteUserProjectMutationHookResult = ReturnType<typeof useDeleteUserProjectMutation>;
export type DeleteUserProjectMutationResult = Apollo.MutationResult<DeleteUserProjectMutation>;
export type DeleteUserProjectMutationOptions = Apollo.BaseMutationOptions<DeleteUserProjectMutation, DeleteUserProjectMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation ForgotPassword($email: String!) {
  forgotPassword(email: $email)
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logout
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const ResendVerificationEmailDocument = gql`
    mutation ResendVerificationEmail($email: String!) {
  resendVerificationEmail(email: $email)
}
    `;
export type ResendVerificationEmailMutationFn = Apollo.MutationFunction<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>;

/**
 * __useResendVerificationEmailMutation__
 *
 * To run a mutation, you first call `useResendVerificationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendVerificationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendVerificationEmailMutation, { data, loading, error }] = useResendVerificationEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResendVerificationEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>(ResendVerificationEmailDocument, options);
      }
export type ResendVerificationEmailMutationHookResult = ReturnType<typeof useResendVerificationEmailMutation>;
export type ResendVerificationEmailMutationResult = Apollo.MutationResult<ResendVerificationEmailMutation>;
export type ResendVerificationEmailMutationOptions = Apollo.BaseMutationOptions<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($token: String!, $password: String!, $confirmPassword: String!) {
  resetPassword(
    token: $token
    password: $password
    confirmPassword: $confirmPassword
  )
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      token: // value for 'token'
 *      password: // value for 'password'
 *      confirmPassword: // value for 'confirmPassword'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const SendCallSheetDocumentDocument = gql`
    mutation sendCallSheetDocument($callSheetId: String!, $sendTest: Boolean, $addMeToEmailList: Boolean, $sendSMS: Boolean, $resetConfirmations: Boolean, $message: String) {
  sendCallSheetDocument(
    callSheetId: $callSheetId
    sendTest: $sendTest
    addMeToEmailList: $addMeToEmailList
    sendSMS: $sendSMS
    resetConfirmations: $resetConfirmations
    message: $message
  ) {
    message
    error
  }
}
    `;
export type SendCallSheetDocumentMutationFn = Apollo.MutationFunction<SendCallSheetDocumentMutation, SendCallSheetDocumentMutationVariables>;

/**
 * __useSendCallSheetDocumentMutation__
 *
 * To run a mutation, you first call `useSendCallSheetDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCallSheetDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCallSheetDocumentMutation, { data, loading, error }] = useSendCallSheetDocumentMutation({
 *   variables: {
 *      callSheetId: // value for 'callSheetId'
 *      sendTest: // value for 'sendTest'
 *      addMeToEmailList: // value for 'addMeToEmailList'
 *      sendSMS: // value for 'sendSMS'
 *      resetConfirmations: // value for 'resetConfirmations'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSendCallSheetDocumentMutation(baseOptions?: Apollo.MutationHookOptions<SendCallSheetDocumentMutation, SendCallSheetDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendCallSheetDocumentMutation, SendCallSheetDocumentMutationVariables>(SendCallSheetDocumentDocument, options);
      }
export type SendCallSheetDocumentMutationHookResult = ReturnType<typeof useSendCallSheetDocumentMutation>;
export type SendCallSheetDocumentMutationResult = Apollo.MutationResult<SendCallSheetDocumentMutation>;
export type SendCallSheetDocumentMutationOptions = Apollo.BaseMutationOptions<SendCallSheetDocumentMutation, SendCallSheetDocumentMutationVariables>;
export const TokenAuthDocument = gql`
    mutation TokenAuth($email_or_phone: String!, $password: String, $socialAuthProvider: SocialAuthProvider, $tokenID: String) {
  tokenAuth(
    email_or_phone: $email_or_phone
    password: $password
    socialAuthProvider: $socialAuthProvider
    tokenID: $tokenID
  ) {
    token
    refresh_token
    payload
  }
}
    `;
export type TokenAuthMutationFn = Apollo.MutationFunction<TokenAuthMutation, TokenAuthMutationVariables>;

/**
 * __useTokenAuthMutation__
 *
 * To run a mutation, you first call `useTokenAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTokenAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tokenAuthMutation, { data, loading, error }] = useTokenAuthMutation({
 *   variables: {
 *      email_or_phone: // value for 'email_or_phone'
 *      password: // value for 'password'
 *      socialAuthProvider: // value for 'socialAuthProvider'
 *      tokenID: // value for 'tokenID'
 *   },
 * });
 */
export function useTokenAuthMutation(baseOptions?: Apollo.MutationHookOptions<TokenAuthMutation, TokenAuthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TokenAuthMutation, TokenAuthMutationVariables>(TokenAuthDocument, options);
      }
export type TokenAuthMutationHookResult = ReturnType<typeof useTokenAuthMutation>;
export type TokenAuthMutationResult = Apollo.MutationResult<TokenAuthMutation>;
export type TokenAuthMutationOptions = Apollo.BaseMutationOptions<TokenAuthMutation, TokenAuthMutationVariables>;
export const UpdateCalendarDocument = gql`
    mutation UpdateCalendar($calendar_id: String!, $title: String, $start_date: Date, $end_date: Date, $color: String) {
  updateCalendar(
    calendar_id: $calendar_id
    title: $title
    start_date: $start_date
    end_date: $end_date
    color: $color
  )
}
    `;
export type UpdateCalendarMutationFn = Apollo.MutationFunction<UpdateCalendarMutation, UpdateCalendarMutationVariables>;

/**
 * __useUpdateCalendarMutation__
 *
 * To run a mutation, you first call `useUpdateCalendarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalendarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCalendarMutation, { data, loading, error }] = useUpdateCalendarMutation({
 *   variables: {
 *      calendar_id: // value for 'calendar_id'
 *      title: // value for 'title'
 *      start_date: // value for 'start_date'
 *      end_date: // value for 'end_date'
 *      color: // value for 'color'
 *   },
 * });
 */
export function useUpdateCalendarMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCalendarMutation, UpdateCalendarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCalendarMutation, UpdateCalendarMutationVariables>(UpdateCalendarDocument, options);
      }
export type UpdateCalendarMutationHookResult = ReturnType<typeof useUpdateCalendarMutation>;
export type UpdateCalendarMutationResult = Apollo.MutationResult<UpdateCalendarMutation>;
export type UpdateCalendarMutationOptions = Apollo.BaseMutationOptions<UpdateCalendarMutation, UpdateCalendarMutationVariables>;
export const UpdateCallSheetDocument = gql`
    mutation updateCallSheet($id: String!, $title: String, $date: String, $time: String, $day_start: Int, $day_final: Int, $temperature: Float, $temperature_max: Float, $temperature_min: Float, $comment: String, $category: String, $add_or_update_events: [CallSheetEventInput], $delete_events: [String], $add_or_update_location: [LocationInput], $delete_location: [String], $add_creative_document: [String], $delete_creative_document: [String], $add_or_update_schedule: [CallSheetScheduleUpdateInput], $delete_schedule: [String], $add_or_update_participant: [CallSheetParticipantInput], $delete_participant: [CallSheetParticipantInput]) {
  updateCallSheet(
    id: $id
    title: $title
    date: $date
    time: $time
    day_start: $day_start
    day_final: $day_final
    temperature: $temperature
    temperature_max: $temperature_max
    temperature_min: $temperature_min
    comment: $comment
    category: $category
    add_or_update_events: $add_or_update_events
    delete_events: $delete_events
    add_or_update_location: $add_or_update_location
    delete_location: $delete_location
    add_creative_document: $add_creative_document
    delete_creative_document: $delete_creative_document
    add_or_update_schedule: $add_or_update_schedule
    delete_schedule: $delete_schedule
    add_or_update_participant: $add_or_update_participant
    delete_participant: $delete_participant
  ) {
    id
  }
}
    `;
export type UpdateCallSheetMutationFn = Apollo.MutationFunction<UpdateCallSheetMutation, UpdateCallSheetMutationVariables>;

/**
 * __useUpdateCallSheetMutation__
 *
 * To run a mutation, you first call `useUpdateCallSheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCallSheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCallSheetMutation, { data, loading, error }] = useUpdateCallSheetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      date: // value for 'date'
 *      time: // value for 'time'
 *      day_start: // value for 'day_start'
 *      day_final: // value for 'day_final'
 *      temperature: // value for 'temperature'
 *      temperature_max: // value for 'temperature_max'
 *      temperature_min: // value for 'temperature_min'
 *      comment: // value for 'comment'
 *      category: // value for 'category'
 *      add_or_update_events: // value for 'add_or_update_events'
 *      delete_events: // value for 'delete_events'
 *      add_or_update_location: // value for 'add_or_update_location'
 *      delete_location: // value for 'delete_location'
 *      add_creative_document: // value for 'add_creative_document'
 *      delete_creative_document: // value for 'delete_creative_document'
 *      add_or_update_schedule: // value for 'add_or_update_schedule'
 *      delete_schedule: // value for 'delete_schedule'
 *      add_or_update_participant: // value for 'add_or_update_participant'
 *      delete_participant: // value for 'delete_participant'
 *   },
 * });
 */
export function useUpdateCallSheetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCallSheetMutation, UpdateCallSheetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCallSheetMutation, UpdateCallSheetMutationVariables>(UpdateCallSheetDocument, options);
      }
export type UpdateCallSheetMutationHookResult = ReturnType<typeof useUpdateCallSheetMutation>;
export type UpdateCallSheetMutationResult = Apollo.MutationResult<UpdateCallSheetMutation>;
export type UpdateCallSheetMutationOptions = Apollo.BaseMutationOptions<UpdateCallSheetMutation, UpdateCallSheetMutationVariables>;
export const UpdateDocumentTypeDocument = gql`
    mutation UpdateDocumentType($documents: [UpdateDocumentTypeInput!]!) {
  updateDocumentType(documents: $documents)
}
    `;
export type UpdateDocumentTypeMutationFn = Apollo.MutationFunction<UpdateDocumentTypeMutation, UpdateDocumentTypeMutationVariables>;

/**
 * __useUpdateDocumentTypeMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentTypeMutation, { data, loading, error }] = useUpdateDocumentTypeMutation({
 *   variables: {
 *      documents: // value for 'documents'
 *   },
 * });
 */
export function useUpdateDocumentTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocumentTypeMutation, UpdateDocumentTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDocumentTypeMutation, UpdateDocumentTypeMutationVariables>(UpdateDocumentTypeDocument, options);
      }
export type UpdateDocumentTypeMutationHookResult = ReturnType<typeof useUpdateDocumentTypeMutation>;
export type UpdateDocumentTypeMutationResult = Apollo.MutationResult<UpdateDocumentTypeMutation>;
export type UpdateDocumentTypeMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentTypeMutation, UpdateDocumentTypeMutationVariables>;
export const UpdateLocationDocument = gql`
    mutation UpdateLocation($location_id: String!, $name: String, $set_address: String, $zipcode: String, $country_id: Int, $parking_address: String, $link_maps_set_address: String, $link_maps_parking_address: String, $link_maps_hospital_address: String, $parking_instructions: String, $nearest_hospital_address: String, $location_contact: String, $location_notes: String, $add_files: [LocationFileInput], $delete_files: [String]) {
  updateLocation(
    location_id: $location_id
    name: $name
    set_address: $set_address
    link_maps_set_address: $link_maps_set_address
    link_maps_parking_address: $link_maps_parking_address
    link_maps_hospital_address: $link_maps_hospital_address
    parking_address: $parking_address
    parking_instructions: $parking_instructions
    nearest_hospital_address: $nearest_hospital_address
    location_contact: $location_contact
    location_notes: $location_notes
    add_files: $add_files
    delete_files: $delete_files
    zipcode: $zipcode
    country_id: $country_id
  ) {
    id
  }
}
    `;
export type UpdateLocationMutationFn = Apollo.MutationFunction<UpdateLocationMutation, UpdateLocationMutationVariables>;

/**
 * __useUpdateLocationMutation__
 *
 * To run a mutation, you first call `useUpdateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationMutation, { data, loading, error }] = useUpdateLocationMutation({
 *   variables: {
 *      location_id: // value for 'location_id'
 *      name: // value for 'name'
 *      set_address: // value for 'set_address'
 *      zipcode: // value for 'zipcode'
 *      country_id: // value for 'country_id'
 *      parking_address: // value for 'parking_address'
 *      link_maps_set_address: // value for 'link_maps_set_address'
 *      link_maps_parking_address: // value for 'link_maps_parking_address'
 *      link_maps_hospital_address: // value for 'link_maps_hospital_address'
 *      parking_instructions: // value for 'parking_instructions'
 *      nearest_hospital_address: // value for 'nearest_hospital_address'
 *      location_contact: // value for 'location_contact'
 *      location_notes: // value for 'location_notes'
 *      add_files: // value for 'add_files'
 *      delete_files: // value for 'delete_files'
 *   },
 * });
 */
export function useUpdateLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationMutation, UpdateLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocationMutation, UpdateLocationMutationVariables>(UpdateLocationDocument, options);
      }
export type UpdateLocationMutationHookResult = ReturnType<typeof useUpdateLocationMutation>;
export type UpdateLocationMutationResult = Apollo.MutationResult<UpdateLocationMutation>;
export type UpdateLocationMutationOptions = Apollo.BaseMutationOptions<UpdateLocationMutation, UpdateLocationMutationVariables>;
export const UpdateNoteDocument = gql`
    mutation UpdateNote($note_id: Int!, $title: String, $content: String!) {
  updateNote(note_id: $note_id, title: $title, content: $content) {
    id
  }
}
    `;
export type UpdateNoteMutationFn = Apollo.MutationFunction<UpdateNoteMutation, UpdateNoteMutationVariables>;

/**
 * __useUpdateNoteMutation__
 *
 * To run a mutation, you first call `useUpdateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNoteMutation, { data, loading, error }] = useUpdateNoteMutation({
 *   variables: {
 *      note_id: // value for 'note_id'
 *      title: // value for 'title'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useUpdateNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNoteMutation, UpdateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNoteMutation, UpdateNoteMutationVariables>(UpdateNoteDocument, options);
      }
export type UpdateNoteMutationHookResult = ReturnType<typeof useUpdateNoteMutation>;
export type UpdateNoteMutationResult = Apollo.MutationResult<UpdateNoteMutation>;
export type UpdateNoteMutationOptions = Apollo.BaseMutationOptions<UpdateNoteMutation, UpdateNoteMutationVariables>;
export const UpdateProfileDocument = gql`
    mutation UpdateProfile($first_name: String, $last_name: String, $job_title_id: String, $avatar: String) {
  updateProfile(
    first_name: $first_name
    last_name: $last_name
    job_title_id: $job_title_id
    avatar: $avatar
  ) {
    id
    username
    email
    phone
    first_name
    last_name
    full_name
    url_avatar
    job_title {
      id
      name
    }
  }
}
    `;
export type UpdateProfileMutationFn = Apollo.MutationFunction<UpdateProfileMutation, UpdateProfileMutationVariables>;

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      first_name: // value for 'first_name'
 *      last_name: // value for 'last_name'
 *      job_title_id: // value for 'job_title_id'
 *      avatar: // value for 'avatar'
 *   },
 * });
 */
export function useUpdateProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileMutation, UpdateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfileMutation, UpdateProfileMutationVariables>(UpdateProfileDocument, options);
      }
export type UpdateProfileMutationHookResult = ReturnType<typeof useUpdateProfileMutation>;
export type UpdateProfileMutationResult = Apollo.MutationResult<UpdateProfileMutation>;
export type UpdateProfileMutationOptions = Apollo.BaseMutationOptions<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const UpdateProjectDocument = gql`
    mutation UpdateProject($id: String!, $company_id: String, $project_name: String, $start_date: Date, $end_date: Date, $num_project: String, $company_manager: [CompanyManagerInput], $project_manager: [ProjectManagerInput], $client_logo: String) {
  updateProject(
    id: $id
    company_id: $company_id
    project_name: $project_name
    start_date: $start_date
    end_date: $end_date
    num_project: $num_project
    company_manager: $company_manager
    project_manager: $project_manager
    client_logo: $client_logo
  ) {
    id
  }
}
    `;
export type UpdateProjectMutationFn = Apollo.MutationFunction<UpdateProjectMutation, UpdateProjectMutationVariables>;

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      company_id: // value for 'company_id'
 *      project_name: // value for 'project_name'
 *      start_date: // value for 'start_date'
 *      end_date: // value for 'end_date'
 *      num_project: // value for 'num_project'
 *      company_manager: // value for 'company_manager'
 *      project_manager: // value for 'project_manager'
 *      client_logo: // value for 'client_logo'
 *   },
 * });
 */
export function useUpdateProjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectMutation, UpdateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument, options);
      }
export type UpdateProjectMutationHookResult = ReturnType<typeof useUpdateProjectMutation>;
export type UpdateProjectMutationResult = Apollo.MutationResult<UpdateProjectMutation>;
export type UpdateProjectMutationOptions = Apollo.BaseMutationOptions<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const UpdateUserProjectDocument = gql`
    mutation UpdateUserProject($project_id: String!, $users: [AddUserInput!]!) {
  updateUserProject(project_id: $project_id, users: $users)
}
    `;
export type UpdateUserProjectMutationFn = Apollo.MutationFunction<UpdateUserProjectMutation, UpdateUserProjectMutationVariables>;

/**
 * __useUpdateUserProjectMutation__
 *
 * To run a mutation, you first call `useUpdateUserProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProjectMutation, { data, loading, error }] = useUpdateUserProjectMutation({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      users: // value for 'users'
 *   },
 * });
 */
export function useUpdateUserProjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserProjectMutation, UpdateUserProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserProjectMutation, UpdateUserProjectMutationVariables>(UpdateUserProjectDocument, options);
      }
export type UpdateUserProjectMutationHookResult = ReturnType<typeof useUpdateUserProjectMutation>;
export type UpdateUserProjectMutationResult = Apollo.MutationResult<UpdateUserProjectMutation>;
export type UpdateUserProjectMutationOptions = Apollo.BaseMutationOptions<UpdateUserProjectMutation, UpdateUserProjectMutationVariables>;
export const UploadCompanyLogoDocument = gql`
    mutation UploadCompanyLogo($logo: Upload!) {
  uploadCompanyLogo(logo: $logo) {
    company_id
    url_file
  }
}
    `;
export type UploadCompanyLogoMutationFn = Apollo.MutationFunction<UploadCompanyLogoMutation, UploadCompanyLogoMutationVariables>;

/**
 * __useUploadCompanyLogoMutation__
 *
 * To run a mutation, you first call `useUploadCompanyLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadCompanyLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCompanyLogoMutation, { data, loading, error }] = useUploadCompanyLogoMutation({
 *   variables: {
 *      logo: // value for 'logo'
 *   },
 * });
 */
export function useUploadCompanyLogoMutation(baseOptions?: Apollo.MutationHookOptions<UploadCompanyLogoMutation, UploadCompanyLogoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadCompanyLogoMutation, UploadCompanyLogoMutationVariables>(UploadCompanyLogoDocument, options);
      }
export type UploadCompanyLogoMutationHookResult = ReturnType<typeof useUploadCompanyLogoMutation>;
export type UploadCompanyLogoMutationResult = Apollo.MutationResult<UploadCompanyLogoMutation>;
export type UploadCompanyLogoMutationOptions = Apollo.BaseMutationOptions<UploadCompanyLogoMutation, UploadCompanyLogoMutationVariables>;
export const UploadCreativeDocumentDocument = gql`
    mutation UploadCreativeDocument($project_id: String!, $documents: [CreativeDocumentsInput!]!) {
  uploadCreativeDocument(project_id: $project_id, documents: $documents)
}
    `;
export type UploadCreativeDocumentMutationFn = Apollo.MutationFunction<UploadCreativeDocumentMutation, UploadCreativeDocumentMutationVariables>;

/**
 * __useUploadCreativeDocumentMutation__
 *
 * To run a mutation, you first call `useUploadCreativeDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadCreativeDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCreativeDocumentMutation, { data, loading, error }] = useUploadCreativeDocumentMutation({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      documents: // value for 'documents'
 *   },
 * });
 */
export function useUploadCreativeDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UploadCreativeDocumentMutation, UploadCreativeDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadCreativeDocumentMutation, UploadCreativeDocumentMutationVariables>(UploadCreativeDocumentDocument, options);
      }
export type UploadCreativeDocumentMutationHookResult = ReturnType<typeof useUploadCreativeDocumentMutation>;
export type UploadCreativeDocumentMutationResult = Apollo.MutationResult<UploadCreativeDocumentMutation>;
export type UploadCreativeDocumentMutationOptions = Apollo.BaseMutationOptions<UploadCreativeDocumentMutation, UploadCreativeDocumentMutationVariables>;
export const UserSignupDocument = gql`
    mutation UserSignup($firstName: String!, $lastName: String!, $email: String!, $jobTitle: String!, $phone: String!, $password: String!, $confirmPassword: String!) {
  userSignup(
    firstName: $firstName
    lastName: $lastName
    email: $email
    job_title_id: $jobTitle
    phone: $phone
    password: $password
    confirmPassword: $confirmPassword
  ) {
    id
    firstName
    lastName
    email
    job_title_id
    phone
  }
}
    `;
export type UserSignupMutationFn = Apollo.MutationFunction<UserSignupMutation, UserSignupMutationVariables>;

/**
 * __useUserSignupMutation__
 *
 * To run a mutation, you first call `useUserSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userSignupMutation, { data, loading, error }] = useUserSignupMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      jobTitle: // value for 'jobTitle'
 *      phone: // value for 'phone'
 *      password: // value for 'password'
 *      confirmPassword: // value for 'confirmPassword'
 *   },
 * });
 */
export function useUserSignupMutation(baseOptions?: Apollo.MutationHookOptions<UserSignupMutation, UserSignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserSignupMutation, UserSignupMutationVariables>(UserSignupDocument, options);
      }
export type UserSignupMutationHookResult = ReturnType<typeof useUserSignupMutation>;
export type UserSignupMutationResult = Apollo.MutationResult<UserSignupMutation>;
export type UserSignupMutationOptions = Apollo.BaseMutationOptions<UserSignupMutation, UserSignupMutationVariables>;
export const VerifyEmailDocument = gql`
    mutation VerifyEmail($token: String!) {
  verifyEmail(token: $token) {
    token
    refresh_token
    payload
  }
}
    `;
export type VerifyEmailMutationFn = Apollo.MutationFunction<VerifyEmailMutation, VerifyEmailMutationVariables>;

/**
 * __useVerifyEmailMutation__
 *
 * To run a mutation, you first call `useVerifyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailMutation, { data, loading, error }] = useVerifyEmailMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyEmailMutation(baseOptions?: Apollo.MutationHookOptions<VerifyEmailMutation, VerifyEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyEmailMutation, VerifyEmailMutationVariables>(VerifyEmailDocument, options);
      }
export type VerifyEmailMutationHookResult = ReturnType<typeof useVerifyEmailMutation>;
export type VerifyEmailMutationResult = Apollo.MutationResult<VerifyEmailMutation>;
export type VerifyEmailMutationOptions = Apollo.BaseMutationOptions<VerifyEmailMutation, VerifyEmailMutationVariables>;
export const CompanyInfoDocument = gql`
    query CompanyInfo($company_id: String!) {
  companyInfo(company_id: $company_id) {
    id
    address
    email
    phone
    company_name
    url_file
    company_managers {
      id
      email
      phone
      full_name
      url_avatar
    }
  }
}
    `;

/**
 * __useCompanyInfoQuery__
 *
 * To run a query within a React component, call `useCompanyInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyInfoQuery({
 *   variables: {
 *      company_id: // value for 'company_id'
 *   },
 * });
 */
export function useCompanyInfoQuery(baseOptions: Apollo.QueryHookOptions<CompanyInfoQuery, CompanyInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyInfoQuery, CompanyInfoQueryVariables>(CompanyInfoDocument, options);
      }
export function useCompanyInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyInfoQuery, CompanyInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyInfoQuery, CompanyInfoQueryVariables>(CompanyInfoDocument, options);
        }
export type CompanyInfoQueryHookResult = ReturnType<typeof useCompanyInfoQuery>;
export type CompanyInfoLazyQueryHookResult = ReturnType<typeof useCompanyInfoLazyQuery>;
export type CompanyInfoQueryResult = Apollo.QueryResult<CompanyInfoQuery, CompanyInfoQueryVariables>;
export const CompanyListDocument = gql`
    query CompanyList {
  companyList {
    id
    company_name
    email
  }
}
    `;

/**
 * __useCompanyListQuery__
 *
 * To run a query within a React component, call `useCompanyListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyListQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanyListQuery(baseOptions?: Apollo.QueryHookOptions<CompanyListQuery, CompanyListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyListQuery, CompanyListQueryVariables>(CompanyListDocument, options);
      }
export function useCompanyListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyListQuery, CompanyListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyListQuery, CompanyListQueryVariables>(CompanyListDocument, options);
        }
export type CompanyListQueryHookResult = ReturnType<typeof useCompanyListQuery>;
export type CompanyListLazyQueryHookResult = ReturnType<typeof useCompanyListLazyQuery>;
export type CompanyListQueryResult = Apollo.QueryResult<CompanyListQuery, CompanyListQueryVariables>;
export const GetCompanyManagerListDocument = gql`
    query GetCompanyManagerList($name_or_email: String!) {
  getCompanyManagerList(name_or_email: $name_or_email) {
    id
    email
    full_name
    url_avatar
    phone
  }
}
    `;

/**
 * __useGetCompanyManagerListQuery__
 *
 * To run a query within a React component, call `useGetCompanyManagerListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyManagerListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyManagerListQuery({
 *   variables: {
 *      name_or_email: // value for 'name_or_email'
 *   },
 * });
 */
export function useGetCompanyManagerListQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyManagerListQuery, GetCompanyManagerListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyManagerListQuery, GetCompanyManagerListQueryVariables>(GetCompanyManagerListDocument, options);
      }
export function useGetCompanyManagerListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyManagerListQuery, GetCompanyManagerListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyManagerListQuery, GetCompanyManagerListQueryVariables>(GetCompanyManagerListDocument, options);
        }
export type GetCompanyManagerListQueryHookResult = ReturnType<typeof useGetCompanyManagerListQuery>;
export type GetCompanyManagerListLazyQueryHookResult = ReturnType<typeof useGetCompanyManagerListLazyQuery>;
export type GetCompanyManagerListQueryResult = Apollo.QueryResult<GetCompanyManagerListQuery, GetCompanyManagerListQueryVariables>;
export const GetCallSheetDocument = gql`
    query getCallSheet($call_sheet_id: String!) {
  getCallSheet(call_sheet_id: $call_sheet_id) {
    id
    project {
      id
      client_logo_url
      num_project
      project_name
      start_date
      end_date
      state
      status
      is_new_project
      company {
        id
        company_name
        address
        email
        phone
        url_file
        company_managers {
          id
          username
          email
          phone
          first_name
          last_name
          full_name
          url_avatar
          job_title {
            id
            order
            name
          }
        }
      }
      company_managers {
        id
        user_id
        username
        email
        phone
        first_name
        last_name
        full_name
        user_role
        url_avatar
      }
      project_managers {
        id
        user_id
        username
        email
        phone
        first_name
        last_name
        full_name
        user_role
        url_avatar
      }
    }
    title
    time
    date
    day_start
    day_final
    file_url
    temperature
    temperature_max
    temperature_min
    comment
    category
    confirmed_participants
    total_participants
    events {
      id
      name
      time
    }
    creative_document {
      id
      file
      file_name
      link_url
      document_type
      date
      created_by
      assigned_in_call_sheet
    }
    location {
      id
      name
      set_address
      zipcode
      project_id
      parking_address
      parking_instructions
      nearest_hospital_address
      location_contact
      location_notes
      order
      link_maps_set_address
      link_maps_parking_address
      link_maps_hospital_address
      assigned_in_call_sheet
      files {
        id
        file
        file_name
      }
    }
    schedule {
      id
      call_sheet_id
      scene
      description
      cast
      location
      time
      deleted
    }
    participant {
      id
      group
      user {
        id
        username
        email
        phone
        first_name
        last_name
        full_name
        url_avatar
        job_title {
          id
          name
        }
      }
      time
      deleted
    }
    participant_by_category {
      name
      title
      users {
        approved_call_sheet
        time_call_sheet
        assigned_in_call_sheet
        full_name
        first_name
        last_name
        email
        phone
        job_title {
          id
          name
        }
      }
    }
    s3_url
  }
}
    `;

/**
 * __useGetCallSheetQuery__
 *
 * To run a query within a React component, call `useGetCallSheetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCallSheetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCallSheetQuery({
 *   variables: {
 *      call_sheet_id: // value for 'call_sheet_id'
 *   },
 * });
 */
export function useGetCallSheetQuery(baseOptions: Apollo.QueryHookOptions<GetCallSheetQuery, GetCallSheetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCallSheetQuery, GetCallSheetQueryVariables>(GetCallSheetDocument, options);
      }
export function useGetCallSheetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCallSheetQuery, GetCallSheetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCallSheetQuery, GetCallSheetQueryVariables>(GetCallSheetDocument, options);
        }
export type GetCallSheetQueryHookResult = ReturnType<typeof useGetCallSheetQuery>;
export type GetCallSheetLazyQueryHookResult = ReturnType<typeof useGetCallSheetLazyQuery>;
export type GetCallSheetQueryResult = Apollo.QueryResult<GetCallSheetQuery, GetCallSheetQueryVariables>;
export const GetInfoCallSheetParticipantDocument = gql`
    query getInfoCallSheetParticipant($call_sheet_id: String!, $participant_id: String!) {
  getInfoCallSheetParticipant(
    call_sheet_id: $call_sheet_id
    participant_id: $participant_id
  ) {
    user_name
    time
    confirmation_date
  }
}
    `;

/**
 * __useGetInfoCallSheetParticipantQuery__
 *
 * To run a query within a React component, call `useGetInfoCallSheetParticipantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInfoCallSheetParticipantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInfoCallSheetParticipantQuery({
 *   variables: {
 *      call_sheet_id: // value for 'call_sheet_id'
 *      participant_id: // value for 'participant_id'
 *   },
 * });
 */
export function useGetInfoCallSheetParticipantQuery(baseOptions: Apollo.QueryHookOptions<GetInfoCallSheetParticipantQuery, GetInfoCallSheetParticipantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInfoCallSheetParticipantQuery, GetInfoCallSheetParticipantQueryVariables>(GetInfoCallSheetParticipantDocument, options);
      }
export function useGetInfoCallSheetParticipantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInfoCallSheetParticipantQuery, GetInfoCallSheetParticipantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInfoCallSheetParticipantQuery, GetInfoCallSheetParticipantQueryVariables>(GetInfoCallSheetParticipantDocument, options);
        }
export type GetInfoCallSheetParticipantQueryHookResult = ReturnType<typeof useGetInfoCallSheetParticipantQuery>;
export type GetInfoCallSheetParticipantLazyQueryHookResult = ReturnType<typeof useGetInfoCallSheetParticipantLazyQuery>;
export type GetInfoCallSheetParticipantQueryResult = Apollo.QueryResult<GetInfoCallSheetParticipantQuery, GetInfoCallSheetParticipantQueryVariables>;
export const GetParticipantsForCallSheetDocument = gql`
    query GetParticipantsForCallSheet($name_or_email: String, $project_id: String!, $user_limit: Int, $call_sheet_id: String) {
  getParticipantsForCallSheet(
    name_or_email: $name_or_email
    project_id: $project_id
    user_limit: $user_limit
    call_sheet_id: $call_sheet_id
  ) {
    name
    title
    users {
      id
      full_name
      job_title {
        id
        name
      }
      username
      email
      phone
      assigned_in_call_sheet
      time_call_sheet
      approved_call_sheet
    }
  }
}
    `;

/**
 * __useGetParticipantsForCallSheetQuery__
 *
 * To run a query within a React component, call `useGetParticipantsForCallSheetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipantsForCallSheetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipantsForCallSheetQuery({
 *   variables: {
 *      name_or_email: // value for 'name_or_email'
 *      project_id: // value for 'project_id'
 *      user_limit: // value for 'user_limit'
 *      call_sheet_id: // value for 'call_sheet_id'
 *   },
 * });
 */
export function useGetParticipantsForCallSheetQuery(baseOptions: Apollo.QueryHookOptions<GetParticipantsForCallSheetQuery, GetParticipantsForCallSheetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParticipantsForCallSheetQuery, GetParticipantsForCallSheetQueryVariables>(GetParticipantsForCallSheetDocument, options);
      }
export function useGetParticipantsForCallSheetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParticipantsForCallSheetQuery, GetParticipantsForCallSheetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParticipantsForCallSheetQuery, GetParticipantsForCallSheetQueryVariables>(GetParticipantsForCallSheetDocument, options);
        }
export type GetParticipantsForCallSheetQueryHookResult = ReturnType<typeof useGetParticipantsForCallSheetQuery>;
export type GetParticipantsForCallSheetLazyQueryHookResult = ReturnType<typeof useGetParticipantsForCallSheetLazyQuery>;
export type GetParticipantsForCallSheetQueryResult = Apollo.QueryResult<GetParticipantsForCallSheetQuery, GetParticipantsForCallSheetQueryVariables>;
export const GetProjectDocument = gql`
    query GetProject($project_id: String!) {
  getProject(project_id: $project_id) {
    id
    client_logo_url
    start_date
    project_name
    end_date
    num_project
    company {
      id
      email
      company_name
      company_managers {
        id
        email
        phone
        full_name
        url_avatar
      }
    }
    company_managers {
      user_id
      user_role
      full_name
      url_avatar
    }
    project_managers {
      user_id
      user_role
      full_name
      url_avatar
    }
  }
}
    `;

/**
 * __useGetProjectQuery__
 *
 * To run a query within a React component, call `useGetProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *   },
 * });
 */
export function useGetProjectQuery(baseOptions: Apollo.QueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
      }
export function useGetProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
        }
export type GetProjectQueryHookResult = ReturnType<typeof useGetProjectQuery>;
export type GetProjectLazyQueryHookResult = ReturnType<typeof useGetProjectLazyQuery>;
export type GetProjectQueryResult = Apollo.QueryResult<GetProjectQuery, GetProjectQueryVariables>;
export const ListCalendarsDocument = gql`
    query ListCalendars($project_id: String!, $since_date: String, $until_date: String) {
  listCalendars(
    project_id: $project_id
    since_date: $since_date
    until_date: $until_date
  ) {
    id
    title
    start_date
    end_date
    color
  }
}
    `;

/**
 * __useListCalendarsQuery__
 *
 * To run a query within a React component, call `useListCalendarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCalendarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCalendarsQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      since_date: // value for 'since_date'
 *      until_date: // value for 'until_date'
 *   },
 * });
 */
export function useListCalendarsQuery(baseOptions: Apollo.QueryHookOptions<ListCalendarsQuery, ListCalendarsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCalendarsQuery, ListCalendarsQueryVariables>(ListCalendarsDocument, options);
      }
export function useListCalendarsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCalendarsQuery, ListCalendarsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCalendarsQuery, ListCalendarsQueryVariables>(ListCalendarsDocument, options);
        }
export type ListCalendarsQueryHookResult = ReturnType<typeof useListCalendarsQuery>;
export type ListCalendarsLazyQueryHookResult = ReturnType<typeof useListCalendarsLazyQuery>;
export type ListCalendarsQueryResult = Apollo.QueryResult<ListCalendarsQuery, ListCalendarsQueryVariables>;
export const ListCallSheetDocument = gql`
    query ListCallSheet($project_id: String!) {
  listCallSheet(project_id: $project_id) {
    id
    project {
      id
      num_project
      client_logo_url
      project_name
      start_date
      end_date
      state
      status
      is_new_project
      company {
        id
        company_name
        address
        email
        phone
        url_file
        company_managers {
          id
          username
          email
          phone
          first_name
          last_name
          full_name
          url_avatar
          job_title {
            id
            order
            name
          }
        }
      }
      company_managers {
        id
        user_id
        username
        email
        phone
        first_name
        last_name
        full_name
        user_role
        url_avatar
      }
      project_managers {
        id
        user_id
        username
        email
        phone
        first_name
        last_name
        full_name
        user_role
        url_avatar
      }
    }
    title
    time
    day_start
    day_final
    send
    file_url
    date
    comment
    category
    confirmed_participants
    total_participants
    creative_document {
      id
      file
      file_name
      document_type
      date
      created_by
    }
    location {
      id
      name
      set_address
      project_id
      parking_address
      parking_instructions
      nearest_hospital_address
      location_contact
      location_notes
      order
      files {
        id
        file
        file_name
      }
    }
    schedule {
      id
      call_sheet_id
      scene
      description
      cast
      location
      time
      deleted
    }
    participant {
      id
      group
      user {
        id
        username
        email
        phone
        first_name
        last_name
        full_name
        url_avatar
        job_title {
          id
          name
        }
      }
      time
      deleted
    }
  }
}
    `;

/**
 * __useListCallSheetQuery__
 *
 * To run a query within a React component, call `useListCallSheetQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCallSheetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCallSheetQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *   },
 * });
 */
export function useListCallSheetQuery(baseOptions: Apollo.QueryHookOptions<ListCallSheetQuery, ListCallSheetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCallSheetQuery, ListCallSheetQueryVariables>(ListCallSheetDocument, options);
      }
export function useListCallSheetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCallSheetQuery, ListCallSheetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCallSheetQuery, ListCallSheetQueryVariables>(ListCallSheetDocument, options);
        }
export type ListCallSheetQueryHookResult = ReturnType<typeof useListCallSheetQuery>;
export type ListCallSheetLazyQueryHookResult = ReturnType<typeof useListCallSheetLazyQuery>;
export type ListCallSheetQueryResult = Apollo.QueryResult<ListCallSheetQuery, ListCallSheetQueryVariables>;
export const ListCityDocument = gql`
    query ListCity($name: String, $country_id: Int) {
  listCities(name: $name, country_id: $country_id) {
    id
    name
  }
}
    `;

/**
 * __useListCityQuery__
 *
 * To run a query within a React component, call `useListCityQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCityQuery({
 *   variables: {
 *      name: // value for 'name'
 *      country_id: // value for 'country_id'
 *   },
 * });
 */
export function useListCityQuery(baseOptions?: Apollo.QueryHookOptions<ListCityQuery, ListCityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCityQuery, ListCityQueryVariables>(ListCityDocument, options);
      }
export function useListCityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCityQuery, ListCityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCityQuery, ListCityQueryVariables>(ListCityDocument, options);
        }
export type ListCityQueryHookResult = ReturnType<typeof useListCityQuery>;
export type ListCityLazyQueryHookResult = ReturnType<typeof useListCityLazyQuery>;
export type ListCityQueryResult = Apollo.QueryResult<ListCityQuery, ListCityQueryVariables>;
export const ListCreativeDocumentDocument = gql`
    query ListCreativeDocument($project_id: String!) {
  listCreativeDocument(project_id: $project_id) {
    count
    creative_document {
      id
      file
      file_name
      document_type
      date
      link_url
      created_by
    }
  }
}
    `;

/**
 * __useListCreativeDocumentQuery__
 *
 * To run a query within a React component, call `useListCreativeDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCreativeDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCreativeDocumentQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *   },
 * });
 */
export function useListCreativeDocumentQuery(baseOptions: Apollo.QueryHookOptions<ListCreativeDocumentQuery, ListCreativeDocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCreativeDocumentQuery, ListCreativeDocumentQueryVariables>(ListCreativeDocumentDocument, options);
      }
export function useListCreativeDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCreativeDocumentQuery, ListCreativeDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCreativeDocumentQuery, ListCreativeDocumentQueryVariables>(ListCreativeDocumentDocument, options);
        }
export type ListCreativeDocumentQueryHookResult = ReturnType<typeof useListCreativeDocumentQuery>;
export type ListCreativeDocumentLazyQueryHookResult = ReturnType<typeof useListCreativeDocumentLazyQuery>;
export type ListCreativeDocumentQueryResult = Apollo.QueryResult<ListCreativeDocumentQuery, ListCreativeDocumentQueryVariables>;
export const ListDifferentProjectsDocument = gql`
    query ListDifferentProjects($user_type: String!, $per_page: Int!) {
  review: listProject(
    status: "REVIEW"
    user_type: $user_type
    per_page: $per_page
  ) {
    count
    current_page
    per_page
    results {
      id
      project_name
      client_logo_url
      start_date
      end_date
      status
      num_project
      is_new_project
      company {
        id
        company_name
        address
        email
        phone
        url_file
      }
      company_managers {
        id
        user_id
        user_role
        username
        url_avatar
        full_name
      }
      project_managers {
        id
        user_id
        user_role
        username
        phone
        url_avatar
        full_name
      }
    }
  }
  rejected: listProject(
    status: "REJECTED"
    user_type: $user_type
    per_page: $per_page
  ) {
    count
    current_page
    per_page
    results {
      id
      project_name
      client_logo_url
      start_date
      end_date
      status
      num_project
      is_new_project
      company {
        id
        company_name
        address
        email
        phone
        url_file
      }
      company_managers {
        id
        user_id
        user_role
        username
        url_avatar
        full_name
      }
      project_managers {
        id
        user_id
        user_role
        username
        phone
        url_avatar
        full_name
      }
    }
  }
  onGoing: listProject(
    status: "ONGOING"
    user_type: $user_type
    per_page: $per_page
  ) {
    count
    current_page
    per_page
    results {
      id
      project_name
      client_logo_url
      start_date
      end_date
      status
      num_project
      is_new_project
      company {
        id
        company_name
        address
        email
        phone
        url_file
      }
      company_managers {
        id
        user_id
        user_role
        username
        url_avatar
        full_name
      }
      project_managers {
        id
        user_id
        user_role
        username
        phone
        url_avatar
        full_name
      }
    }
  }
  done: listProject(status: "DONE", user_type: $user_type, per_page: $per_page) {
    count
    current_page
    per_page
    results {
      id
      project_name
      client_logo_url
      start_date
      end_date
      status
      num_project
      is_new_project
      company {
        id
        company_name
        address
        email
        phone
        url_file
      }
      company_managers {
        id
        user_id
        user_role
        username
        url_avatar
        full_name
      }
      project_managers {
        id
        user_id
        user_role
        username
        phone
        url_avatar
        full_name
      }
    }
  }
}
    `;

/**
 * __useListDifferentProjectsQuery__
 *
 * To run a query within a React component, call `useListDifferentProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDifferentProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDifferentProjectsQuery({
 *   variables: {
 *      user_type: // value for 'user_type'
 *      per_page: // value for 'per_page'
 *   },
 * });
 */
export function useListDifferentProjectsQuery(baseOptions: Apollo.QueryHookOptions<ListDifferentProjectsQuery, ListDifferentProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDifferentProjectsQuery, ListDifferentProjectsQueryVariables>(ListDifferentProjectsDocument, options);
      }
export function useListDifferentProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDifferentProjectsQuery, ListDifferentProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDifferentProjectsQuery, ListDifferentProjectsQueryVariables>(ListDifferentProjectsDocument, options);
        }
export type ListDifferentProjectsQueryHookResult = ReturnType<typeof useListDifferentProjectsQuery>;
export type ListDifferentProjectsLazyQueryHookResult = ReturnType<typeof useListDifferentProjectsLazyQuery>;
export type ListDifferentProjectsQueryResult = Apollo.QueryResult<ListDifferentProjectsQuery, ListDifferentProjectsQueryVariables>;
export const ListJobTitleDocument = gql`
    query ListJobTitle($name: String, $limit: Int) {
  listJobTitle(name: $name, limit: $limit) {
    id
    name
  }
}
    `;

/**
 * __useListJobTitleQuery__
 *
 * To run a query within a React component, call `useListJobTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useListJobTitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListJobTitleQuery({
 *   variables: {
 *      name: // value for 'name'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListJobTitleQuery(baseOptions?: Apollo.QueryHookOptions<ListJobTitleQuery, ListJobTitleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListJobTitleQuery, ListJobTitleQueryVariables>(ListJobTitleDocument, options);
      }
export function useListJobTitleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListJobTitleQuery, ListJobTitleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListJobTitleQuery, ListJobTitleQueryVariables>(ListJobTitleDocument, options);
        }
export type ListJobTitleQueryHookResult = ReturnType<typeof useListJobTitleQuery>;
export type ListJobTitleLazyQueryHookResult = ReturnType<typeof useListJobTitleLazyQuery>;
export type ListJobTitleQueryResult = Apollo.QueryResult<ListJobTitleQuery, ListJobTitleQueryVariables>;
export const ListLocationsDocument = gql`
    query ListLocations($project_id: String!) {
  listLocations(project_id: $project_id) {
    id
    name
    city {
      id
      name
    }
    set_address
    project_id
    parking_address
    parking_instructions
    nearest_hospital_address
    location_notes
    location_contact
    link_maps_set_address
    link_maps_parking_address
    link_maps_hospital_address
    zipcode
    files {
      id
      file
      file_name
    }
  }
}
    `;

/**
 * __useListLocationsQuery__
 *
 * To run a query within a React component, call `useListLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLocationsQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *   },
 * });
 */
export function useListLocationsQuery(baseOptions: Apollo.QueryHookOptions<ListLocationsQuery, ListLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListLocationsQuery, ListLocationsQueryVariables>(ListLocationsDocument, options);
      }
export function useListLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListLocationsQuery, ListLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListLocationsQuery, ListLocationsQueryVariables>(ListLocationsDocument, options);
        }
export type ListLocationsQueryHookResult = ReturnType<typeof useListLocationsQuery>;
export type ListLocationsLazyQueryHookResult = ReturnType<typeof useListLocationsLazyQuery>;
export type ListLocationsQueryResult = Apollo.QueryResult<ListLocationsQuery, ListLocationsQueryVariables>;
export const ListNotesDocument = gql`
    query ListNotes($project_id: String!, $user_id: String!) {
  listNotes(project_id: $project_id, user_id: $user_id) {
    id
    title
    content
  }
}
    `;

/**
 * __useListNotesQuery__
 *
 * To run a query within a React component, call `useListNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListNotesQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useListNotesQuery(baseOptions: Apollo.QueryHookOptions<ListNotesQuery, ListNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListNotesQuery, ListNotesQueryVariables>(ListNotesDocument, options);
      }
export function useListNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListNotesQuery, ListNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListNotesQuery, ListNotesQueryVariables>(ListNotesDocument, options);
        }
export type ListNotesQueryHookResult = ReturnType<typeof useListNotesQuery>;
export type ListNotesLazyQueryHookResult = ReturnType<typeof useListNotesLazyQuery>;
export type ListNotesQueryResult = Apollo.QueryResult<ListNotesQuery, ListNotesQueryVariables>;
export const ListProjectDocument = gql`
    query ListProject($per_page: Int!, $status: String, $user_type: String, $page: Int) {
  listProject(
    per_page: $per_page
    status: $status
    user_type: $user_type
    page: $page
  ) {
    count
    current_page
    per_page
    results {
      id
      project_name
      client_logo_url
      start_date
      end_date
      status
      num_project
      is_new_project
      company {
        id
        company_name
        address
        email
        phone
        url_file
        company_managers {
          id
          username
          email
          phone
          first_name
          last_name
          full_name
        }
      }
      company_managers {
        id
        user_id
        user_role
        username
        url_avatar
      }
      project_managers {
        id
        user_id
        user_role
        username
        phone
        url_avatar
      }
    }
  }
}
    `;

/**
 * __useListProjectQuery__
 *
 * To run a query within a React component, call `useListProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProjectQuery({
 *   variables: {
 *      per_page: // value for 'per_page'
 *      status: // value for 'status'
 *      user_type: // value for 'user_type'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useListProjectQuery(baseOptions: Apollo.QueryHookOptions<ListProjectQuery, ListProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListProjectQuery, ListProjectQueryVariables>(ListProjectDocument, options);
      }
export function useListProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListProjectQuery, ListProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListProjectQuery, ListProjectQueryVariables>(ListProjectDocument, options);
        }
export type ListProjectQueryHookResult = ReturnType<typeof useListProjectQuery>;
export type ListProjectLazyQueryHookResult = ReturnType<typeof useListProjectLazyQuery>;
export type ListProjectQueryResult = Apollo.QueryResult<ListProjectQuery, ListProjectQueryVariables>;
export const PingDocument = gql`
    query ping {
  ping
}
    `;

/**
 * __usePingQuery__
 *
 * To run a query within a React component, call `usePingQuery` and pass it any options that fit your needs.
 * When your component renders, `usePingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePingQuery({
 *   variables: {
 *   },
 * });
 */
export function usePingQuery(baseOptions?: Apollo.QueryHookOptions<PingQuery, PingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PingQuery, PingQueryVariables>(PingDocument, options);
      }
export function usePingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PingQuery, PingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PingQuery, PingQueryVariables>(PingDocument, options);
        }
export type PingQueryHookResult = ReturnType<typeof usePingQuery>;
export type PingLazyQueryHookResult = ReturnType<typeof usePingLazyQuery>;
export type PingQueryResult = Apollo.QueryResult<PingQuery, PingQueryVariables>;
export const RoleByProjectDocument = gql`
    query RoleByProject($project_id: String!) {
  roleByProject(project_id: $project_id) {
    role
  }
}
    `;

/**
 * __useRoleByProjectQuery__
 *
 * To run a query within a React component, call `useRoleByProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleByProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoleByProjectQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *   },
 * });
 */
export function useRoleByProjectQuery(baseOptions: Apollo.QueryHookOptions<RoleByProjectQuery, RoleByProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoleByProjectQuery, RoleByProjectQueryVariables>(RoleByProjectDocument, options);
      }
export function useRoleByProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoleByProjectQuery, RoleByProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoleByProjectQuery, RoleByProjectQueryVariables>(RoleByProjectDocument, options);
        }
export type RoleByProjectQueryHookResult = ReturnType<typeof useRoleByProjectQuery>;
export type RoleByProjectLazyQueryHookResult = ReturnType<typeof useRoleByProjectLazyQuery>;
export type RoleByProjectQueryResult = Apollo.QueryResult<RoleByProjectQuery, RoleByProjectQueryVariables>;
export const UserInfoDocument = gql`
    query UserInfo {
  userInfo {
    user {
      id
      username
      email
      phone
      first_name
      last_name
      full_name
      url_avatar
      job_title {
        id
        name
      }
    }
    company {
      id
      company_name
      address
      email
      phone
      url_file
    }
    producers_projects
    crew_members_projects
  }
}
    `;

/**
 * __useUserInfoQuery__
 *
 * To run a query within a React component, call `useUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserInfoQuery(baseOptions?: Apollo.QueryHookOptions<UserInfoQuery, UserInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserInfoQuery, UserInfoQueryVariables>(UserInfoDocument, options);
      }
export function useUserInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserInfoQuery, UserInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserInfoQuery, UserInfoQueryVariables>(UserInfoDocument, options);
        }
export type UserInfoQueryHookResult = ReturnType<typeof useUserInfoQuery>;
export type UserInfoLazyQueryHookResult = ReturnType<typeof useUserInfoLazyQuery>;
export type UserInfoQueryResult = Apollo.QueryResult<UserInfoQuery, UserInfoQueryVariables>;
export const UserListDocument = gql`
    query UserList($name_or_email: String!, $company_id: String!, $user_limit: Int) {
  userList(
    name_or_email: $name_or_email
    company_id: $company_id
    user_limit: $user_limit
  ) {
    id
    first_name
    last_name
    full_name
    email
  }
}
    `;

/**
 * __useUserListQuery__
 *
 * To run a query within a React component, call `useUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserListQuery({
 *   variables: {
 *      name_or_email: // value for 'name_or_email'
 *      company_id: // value for 'company_id'
 *      user_limit: // value for 'user_limit'
 *   },
 * });
 */
export function useUserListQuery(baseOptions: Apollo.QueryHookOptions<UserListQuery, UserListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserListQuery, UserListQueryVariables>(UserListDocument, options);
      }
export function useUserListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserListQuery, UserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserListQuery, UserListQueryVariables>(UserListDocument, options);
        }
export type UserListQueryHookResult = ReturnType<typeof useUserListQuery>;
export type UserListLazyQueryHookResult = ReturnType<typeof useUserListLazyQuery>;
export type UserListQueryResult = Apollo.QueryResult<UserListQuery, UserListQueryVariables>;
export const UserListForProjectDocument = gql`
    query UserListForProject($name_or_email: String!, $project_id: String!, $user_limit: Int) {
  userListForProject(
    name_or_email: $name_or_email
    project_id: $project_id
    user_limit: $user_limit
  ) {
    id
    full_name
    email
    job_title {
      name
    }
    phone
  }
}
    `;

/**
 * __useUserListForProjectQuery__
 *
 * To run a query within a React component, call `useUserListForProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserListForProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserListForProjectQuery({
 *   variables: {
 *      name_or_email: // value for 'name_or_email'
 *      project_id: // value for 'project_id'
 *      user_limit: // value for 'user_limit'
 *   },
 * });
 */
export function useUserListForProjectQuery(baseOptions: Apollo.QueryHookOptions<UserListForProjectQuery, UserListForProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserListForProjectQuery, UserListForProjectQueryVariables>(UserListForProjectDocument, options);
      }
export function useUserListForProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserListForProjectQuery, UserListForProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserListForProjectQuery, UserListForProjectQueryVariables>(UserListForProjectDocument, options);
        }
export type UserListForProjectQueryHookResult = ReturnType<typeof useUserListForProjectQuery>;
export type UserListForProjectLazyQueryHookResult = ReturnType<typeof useUserListForProjectLazyQuery>;
export type UserListForProjectQueryResult = Apollo.QueryResult<UserListForProjectQuery, UserListForProjectQueryVariables>;
export const UserListFromProjectDocument = gql`
    query UserListFromProject($name_or_email: String!, $project_id: String!, $user_limit: Int) {
  userListFromProject(
    name_or_email: $name_or_email
    project_id: $project_id
    user_limit: $user_limit
  ) {
    id
    full_name
    job_title {
      name
    }
    email
    url_avatar
    phone
  }
}
    `;

/**
 * __useUserListFromProjectQuery__
 *
 * To run a query within a React component, call `useUserListFromProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserListFromProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserListFromProjectQuery({
 *   variables: {
 *      name_or_email: // value for 'name_or_email'
 *      project_id: // value for 'project_id'
 *      user_limit: // value for 'user_limit'
 *   },
 * });
 */
export function useUserListFromProjectQuery(baseOptions: Apollo.QueryHookOptions<UserListFromProjectQuery, UserListFromProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserListFromProjectQuery, UserListFromProjectQueryVariables>(UserListFromProjectDocument, options);
      }
export function useUserListFromProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserListFromProjectQuery, UserListFromProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserListFromProjectQuery, UserListFromProjectQueryVariables>(UserListFromProjectDocument, options);
        }
export type UserListFromProjectQueryHookResult = ReturnType<typeof useUserListFromProjectQuery>;
export type UserListFromProjectLazyQueryHookResult = ReturnType<typeof useUserListFromProjectLazyQuery>;
export type UserListFromProjectQueryResult = Apollo.QueryResult<UserListFromProjectQuery, UserListFromProjectQueryVariables>;